// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-family: 'Poppins', sans-serif;

  /* Blue (Palatinate Blue) */
  --blue-dark: #1C25A6;
  --blue-100: #232ED1;
  --blue-90: #3943D6;
  --blue-80: #4F58DA;
  --blue-70: #656DDF;
  --blue-60: #7B82E3;
  --blue-50: #9196E8;
  --blue-40: #A7ABED;
  --blue-30: #BDC0F1;
  --blue-20: #D3D5F6;
  --blue-10: #E9EAFA;
  --blue-8: #EDEEFB;
  --blue-4: #F6F7FD;
  --blue-1: #FDFDFF;

  /* Slate Blue (Medium Slate Blue) */
  --slate-blue-dark: #5229FF;
  --slate-blue-100: #7A5AFF;
  --slate-blue-90: #876BFF;
  --slate-blue-80: #957BFF;
  --slate-blue-70: #A28BFF;
  --slate-blue-60: #AF9CFF;
  --slate-blue-50: #BCACFF;
  --slate-blue-40: #CABDFF;
  --slate-blue-30: #D7CDFF;
  --slate-blue-20: #E4DEFF;
  --slate-blue-10: #F2EEFF;
  --slate-blue-8: #F4F2FF;
  --slate-blue-4: #FAF8FF;
  --slate-blue-1: #FEFDFF;

  /* Butterscotch */
  --butterscotch-dark: #BB7D25;
  --butterscotch-100: #D8973C;
  --butterscotch-90: #DCA150;
  --butterscotch-80: #E0AC63;
  --butterscotch-70: #E4B677;
  --butterscotch-60: #E8C18A;
  --butterscotch-50: #EBCB9D;
  --butterscotch-40: #EFD5B1;
  --butterscotch-30: #F3E0C4;
  --butterscotch-20: #F7EAD8;
  --butterscotch-10: #FBF5EB;
  --butterscotch-8: #FCF7EF;
  --butterscotch-4: #FDFBF7;
  --butterscotch-1: #FFFEFD;

  /* Green (Sea Green) */
  --green-dark: #115A38;
  --green-100: #198754;
  --green-90: #309365;
  --green-80: #479F76;
  --green-70: #5EAB87;
  --green-60: #75B798;
  --green-50: #8CC3A9;
  --green-40: #A3CFBB;
  --green-30: #BADBCC;
  --green-20: #D1E7DD;
  --green-10: #E8F3EE;
  --green-8: #EDF5F1;
  --green-4: #F6FAF8;
  --green-1: #FDFEFD;

  /* Red (Chili Red) */
  --red-dark: #B23724;
  --red-100: #D64933;
  --red-90: #DA5B47;
  --red-80: #DE6D5C;
  --red-70: #E28070;
  --red-60: #E69285;
  --red-50: #EBA499;
  --red-40: #EFB6AD;
  --red-30: #F3C8C2;
  --red-20: #F7DBD6;
  --red-10: #FBEDEB;
  --red-8: #FCF0EF;
  --red-4: #FDF8F7;
  --red-1: #FFFDFD;

  /* Gray (Text) */
  --gray-100: #061437;
  --gray-90: #1F2C4B;
  --gray-80: #38435F;
  --gray-70: #515B73;
  --gray-60: #6A7287;
  --gray-50: #82899B;
  --gray-40: #9BA1AF;
  --gray-30: #B4B8C3;
  --gray-20: #CDD0D7;
  --gray-10: #E6E7EB;
  --gray-8: #EBECEF;
  --gray-4: #F5F6F7;
  --gray-1: #FDFDFD;

  /* Deep Sky Blue */
  --deep-sky-blue-100: #02BBFF;

  /* Bright Peony */
  --bright-peony-100: #F26DF9;

  --primary-white: #ffffff;
  --primary-black: #000000;
  --primary-white-transparent: #ffffff99;
  --shadow-focus: 0 0 0 4px #D3D5F6;
  --shadow-level-1: 0 4px 16px 0 #0e243b0f;
  --shadow-level-2: 0 4px 22px 0 #0e243b1a;
  --shadow-level-3: 0 5px 26px 0 #0e243b26;
}

* {
  box-sizing: border-box;
}

html {
  height: 100%;
  font-size: 16px;
}

body {
  margin: 0;
  font-family: var(--font-family);
  font-weight: 400;
  color: var(--gray-100);
  padding: 0;
  margin: 0;
  min-height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  color: var(--blue-100);
}
a:hover {
  color: var(--blue-dark);
}

.p-component {
  font-family: var(--font-family);
}
.p-disabled,
.p-component:disabled {
  opacity: 0.6;
}
.p-component-overlay {
  background-color: rgba(0, 0, 0, 0.4);
  transition-duration: 0.2s;
}

/* spinner */
.p-progress-spinner-circle {
  stroke: var(--gray-40);
  animation: p-progress-spinner-dash 1.5s ease-in-out infinite;
}

/* skeleton */
.p-skeleton {
  background-color: var(--gray-10);
  border-radius: 4px;
}
.p-skeleton:after {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));
}

/* layout mask */
.layout-mask {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
  width: 100%;
  height: 100%;
  animation-duration: 0.4s;
  animation-timing-function: cubic-bezier(0.05, 0.74, 0.2, 0.99);
  animation-fill-mode: forwards;
}

/* button */
.p-button {
  color: var(--primary-white);
  background: var(--blue-100);
  border: 1px solid var(--blue-100);
  padding: 9px 17px;
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  border-radius: 8px;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.01rem;
}
.p-button.button-sm {
  padding: 7px 12px;
  border-radius: 6px;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.01rem;
}
.p-button:enabled:hover,
.p-button:not(button):not(a):not(.p-disabled):hover {
  background: var(--blue-dark);
  border-color: var(--blue-dark);
}
.p-button:focus {
  box-shadow: var(--shadow-focus);
}
.p-button .p-button-label {
  font-weight: 500;
  transition-duration: 0s;
}
.p-button.button-sm .p-button-label {
  font-weight: 400;
}
.p-button.p-button-icon-only {
  width: 38px;
  padding: 9px 0;
}

/* link button */
.p-button.p-button-link {
  background: inherit;
  border: inherit;
  color: inherit;
}
.p-button.p-button-link:enabled:hover,
.p-button.p-button-link:not(button):not(a):not(.p-disabled):hover {
  background: inherit;
  border-color: inherit;
}
.p-button.p-button-link:focus {
  box-shadow: inherit;
}

/* button and icon sizes */
.p-button.button-xl {
  padding: 14px 17px;
  border-radius: 10px;
}
.p-button.button-icon {
  padding: 9px;
}
.p-button.button-icon-xl {
  padding: 6px;
}
.p-button.button-icon.button-xl {
  padding: 14px;
}
.p-button.button-icon-xl.button-xl {
  padding: 11px;
}

/* button tomato*/
.p-button.button-tomato {
  background: var(--red-100);
  border: 1px solid var(--red-100);
}
.p-button.button-tomato:enabled:hover,
.p-button.button-tomato:not(button):not(a):not(.p-disabled):hover {
  background: var(--red-dark);
  border-color: var(--red-dark);
}

/* button outlined */
.p-button.p-button-outlined {
  background-color: var(--primary-white);
  color: var(--gray-60);
  border-color: var(--gray-20);
}
.p-button.p-button-outlined.button-xl {
  color: var(--gray-80);
}
.p-button.p-button-outlined:enabled:hover,
.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-button.p-button-outlined:enabled:active,
.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background-color: var(--gray-1);
  color: var(--gray-100);
  border-color: var(--gray-100);
}
.p-button.p-button-outlined:focus {
  box-shadow: 0px 0px 0px 4px #676e7629;
}
/* button outlined blue*/
.p-button.p-button-outlined.button-blue {
  color: var(--blue-100);
  border-color: var(--blue-100);
}
.p-button.p-button-outlined.button-blue:enabled:hover,
.p-button.p-button-outlined.button-blue:not(button):not(a):not(.p-disabled):hover,
.p-button.p-button-outlined.button-blue:enabled:active,
.p-button.p-button-outlined.button-blue:not(button):not(a):not(.p-disabled):active {
  color: var(--blue-dark);
  border-color: var(--blue-dark);
}

/* button text */
.p-button.p-button-text {
  background-color: transparent;
  color: var(--gray-80);
  border-color: transparent;
  padding: 0;
}
.p-button.p-button-text.button-xl {
  font-size: 15px;
}
.p-button.p-button-text:enabled:hover,
.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-button.p-button-text:enabled:active,
.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-button.p-button-text:focus {
  background-color: transparent;
  color: var(--gray-100);
  border-color: transparent;
  box-shadow: none;
}
/* button text blue*/
.p-button.p-button-text.button-blue {
  color: var(--blue-100);
}
.p-button.p-button-text.button-blue:enabled:hover,
.p-button.p-button-text.button-blue:not(button):not(a):not(.p-disabled):hover,
.p-button.p-button-text.button-blue:enabled:active,
.p-button.p-button-text.button-blue:not(button):not(a):not(.p-disabled):active,
.p-button.p-button-text.button-blue:focus {
  color: var(--blue-dark);
}

/* button severity danger */
.p-button.p-button-danger,
.p-buttonset.p-button-danger > .p-button,
.p-splitbutton.p-button-danger > .p-button,
.p-fileupload-choose.p-button-danger {
  color: var(--red-100);
  background: var(--red-20);
  border: 1px solid var(--red-20);
}
.p-button.p-button-danger:enabled:hover,
.p-button.p-button-danger:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-danger > .p-button:enabled:hover,
.p-buttonset.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-danger > .p-button:enabled:hover,
.p-splitbutton.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-danger:enabled:hover,
.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):hover {
  background: var(--red-20);
  color: var(--red-dark);
  border-color: var(--red-20);
}
.p-button.p-button-danger:enabled:focus,
.p-button.p-button-danger:not(button):not(a):not(.p-disabled):focus,
.p-buttonset.p-button-danger > .p-button:enabled:focus,
.p-buttonset.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-splitbutton.p-button-danger > .p-button:enabled:focus,
.p-splitbutton.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-fileupload-choose.p-button-danger:enabled:focus,
.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):focus {
  box-shadow: 0px 0px 0px 4px var(--red-20);
}
.p-button.p-button-danger:enabled:active,
.p-button.p-button-danger:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-danger > .p-button:enabled:active,
.p-buttonset.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-danger > .p-button:enabled:active,
.p-splitbutton.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-danger:enabled:active,
.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):active {
  background: var(--red-20);
  color: var(--red-100);
  border-color: var(--red-20);
}
.p-button.p-button-danger.p-button-outlined,
.p-buttonset.p-button-danger > .p-button.p-button-outlined,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined,
.p-fileupload-choose.p-button-danger.p-button-outlined {
  background-color: transparent;
  color: var(--red-100);
  border-color: var(--red-100);
}
.p-button.p-button-danger.p-button-outlined:enabled:hover,
.p-button.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-danger > .p-button.p-button-outlined:enabled:hover,
.p-buttonset.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined:enabled:hover,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-danger.p-button-outlined:enabled:hover,
.p-fileupload-choose.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):hover {
  background-color: var(--red-4);
  color: var(--red-dark);
  border-color: var(--red-dark);
}
.p-button.p-button-danger.p-button-outlined:enabled:active,
.p-button.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-danger > .p-button.p-button-outlined:enabled:active,
.p-buttonset.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined:enabled:active,
.p-splitbutton.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-danger.p-button-outlined:enabled:active,
.p-fileupload-choose.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background: var(--red-4);
  color: var(--red-dark);
  border-color: var(--red-4);
}
.p-button.p-button-danger.p-button-text,
.p-buttonset.p-button-danger > .p-button.p-button-text,
.p-splitbutton.p-button-danger > .p-button.p-button-text,
.p-fileupload-choose.p-button-danger.p-button-text {
  background-color: transparent;
  color: var(--red-100);
  border-color: transparent;
}
.p-button.p-button-danger.p-button-text:enabled:hover,
.p-button.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-danger > .p-button.p-button-text:enabled:hover,
.p-buttonset.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-danger > .p-button.p-button-text:enabled:hover,
.p-splitbutton.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-danger.p-button-text:enabled:hover,
.p-fileupload-choose.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):hover {
  background-color: transparent;
  color: var(--red-dark);
  border-color: transparent;
}
.p-button.p-button-danger.p-button-text:enabled:active,
.p-button.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-danger > .p-button.p-button-text:enabled:active,
.p-buttonset.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-danger > .p-button.p-button-text:enabled:active,
.p-splitbutton.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-danger.p-button-text:enabled:active,
.p-fileupload-choose.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):active {
  background-color: transparent;
  color: var(--red-dark);
  border-color: transparent;
}

/* add button */
.p-button.button-add {
  background: var(--gray-1);
  border-color: var(--gray-1);
  color: var(--gray-50);
  border-radius: 4px;
  height: 16px;
  padding: 0;
}
.p-button.button-add:enabled:hover,
.p-button.button-add:not(button):not(a):not(.p-disabled):hover,
.p-button.button-add:enabled:active,
.p-button.button-add:not(button):not(a):not(.p-disabled):active,
.p-button.button-add:focus {
  background: var(--blue-20);
  border-color: var(--blue-20);
  color: var(--blue-100);
  box-shadow: none;
}
.p-button.p-button-text.button-secondary {
  color: var(--gray-50);
}
.p-button.p-button-text.button-secondary:enabled:hover,
.p-button.p-button-text.button-secondary:not(button):not(a):not(.p-disabled):hover,
.p-button.p-button-text.button-secondary:enabled:active,
.p-button.p-button-text.button-secondary:not(button):not(a):not(.p-disabled):active,
.p-button.p-button-text.button-secondary:focus {
  color: var(--gray-80);
}

/* button severity success */
.p-button.p-button-success,
.p-buttonset.p-button-success > .p-button,
.p-splitbutton.p-button-success > .p-button,
.p-fileupload-choose.p-button-success {
  color: var(--green-100);
  background: var(--green-20);
  border: 1px solid var(--green-20);
}
.p-button.p-button-success:enabled:hover,
.p-button.p-button-success:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-success > .p-button:enabled:hover,
.p-buttonset.p-button-success > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-success > .p-button:enabled:hover,
.p-splitbutton.p-button-success > .p-button:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-success:enabled:hover,
.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):hover {
  background: var(--green-20);
  color: var(--green-dark);
  border-color: var(--green-20);
}
.p-button.p-button-success:enabled:focus,
.p-button.p-button-success:not(button):not(a):not(.p-disabled):focus,
.p-buttonset.p-button-success > .p-button:enabled:focus,
.p-buttonset.p-button-success > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-splitbutton.p-button-success > .p-button:enabled:focus,
.p-splitbutton.p-button-success > .p-button:not(button):not(a):not(.p-disabled):focus,
.p-fileupload-choose.p-button-success:enabled:focus,
.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):focus {
  box-shadow: 0px 0px 0px 4px var(--green-20);
}
.p-button.p-button-success:enabled:active,
.p-button.p-button-success:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-success > .p-button:enabled:active,
.p-buttonset.p-button-success > .p-button:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-success > .p-button:enabled:active,
.p-splitbutton.p-button-success > .p-button:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-success:enabled:active,
.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):active {
  background: var(--green-20);
  color: var(--green-100);
  border-color: var(--green-20);
}
.p-button.p-button-success.p-button-outlined,
.p-buttonset.p-button-success > .p-button.p-button-outlined,
.p-splitbutton.p-button-success > .p-button.p-button-outlined,
.p-fileupload-choose.p-button-success.p-button-outlined {
  background-color: transparent;
  color: var(--green-100);
  border-color: var(--green-100);
}
.p-button.p-button-success.p-button-outlined:enabled:hover,
.p-button.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-success > .p-button.p-button-outlined:enabled:hover,
.p-buttonset.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:enabled:hover,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-success.p-button-outlined:enabled:hover,
.p-fileupload-choose.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):hover {
  background-color: var(--green-4);
  color: var(--green-dark);
  border-color: var(--green-dark);
}
.p-button.p-button-success.p-button-outlined:enabled:active,
.p-button.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-success > .p-button.p-button-outlined:enabled:active,
.p-buttonset.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:enabled:active,
.p-splitbutton.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-success.p-button-outlined:enabled:active,
.p-fileupload-choose.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):active {
  background: var(--green-4);
  color: var(--green-dark);
  border-color: var(--green-4);
}
.p-button.p-button-success.p-button-text,
.p-buttonset.p-button-success > .p-button.p-button-text,
.p-splitbutton.p-button-success > .p-button.p-button-text,
.p-fileupload-choose.p-button-success.p-button-text {
  background-color: transparent;
  color: var(--green-100);
  border-color: transparent;
}
.p-button.p-button-success.p-button-text:enabled:hover,
.p-button.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-buttonset.p-button-success > .p-button.p-button-text:enabled:hover,
.p-buttonset.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-splitbutton.p-button-success > .p-button.p-button-text:enabled:hover,
.p-splitbutton.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,
.p-fileupload-choose.p-button-success.p-button-text:enabled:hover,
.p-fileupload-choose.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):hover {
  background-color: transparent;
  color: var(--green-dark);
  border-color: transparent;
}
.p-button.p-button-success.p-button-text:enabled:active,
.p-button.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-buttonset.p-button-success > .p-button.p-button-text:enabled:active,
.p-buttonset.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-splitbutton.p-button-success > .p-button.p-button-text:enabled:active,
.p-splitbutton.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,
.p-fileupload-choose.p-button-success.p-button-text:enabled:active,
.p-fileupload-choose.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):active {
  background-color: transparent;
  color: var(--green-dark);
  border-color: transparent;
}

/* p-selectbutton */
.p-selectbutton {
  display: flex;
  padding: 2px;
  border-radius: 6px;
  background-color: var(--gray-10);
}
.p-selectbutton .p-button {
  flex: 1 1 0%;
  min-width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
  border-radius: 5px;
  height: 28px;
  font-size: 12px;
  line-height: 16px;
  color: var(--gray-60);
  background: transparent;
  box-shadow: none;
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
}
.p-selectbutton .p-button:hover,
.p-selectbutton .p-button:focus {
  color: var(--gray-100);
  background: transparent !important;
}
.p-selectbutton .p-button.p-highlight {
  color: var(--gray-100);
  background: var(--primary-white) !important;
  box-shadow: var(--shadow-level-1);
}
.p-selectbutton .p-button .p-button-label {
  font-weight: 400;
}

.p-selectbutton.selectbutton-lg {
  padding: 1px;
  border-radius: 8px;
}
.p-selectbutton.selectbutton-lg .p-button {
  border-radius: 7px;
  height: 30px;
}
.p-selectbutton.selectbutton-lg .p-button .p-button-label {
  font-weight: 500;
  padding: 0 18px;
}

/* select button
.p-selectbutton .p-button {
  background: var(--primary-white);
  border: 1px solid var(--gray-20);
  color: var(--gray-80);
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
}
.p-selectbutton .p-button .p-button-icon-left,
.p-selectbutton .p-button .p-button-icon-right {
  color: var(--gray-80);
}
.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {
  background: var(prima--primary-whiteeavy-blue-1);
  border-color: var(--gray-20);
  color: var(--gray-100);
}
.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,
.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {
  color: var(--gray-80);
}
.p-selectbutton .p-button.p-highlight {
  background: var(--blue-100);
  border-color: var(--blue-100);
  color: var(--primary-white);
}
.p-selectbutton .p-button.p-highlight .p-button-icon-left,
.p-selectbutton .p-button.p-highlight .p-button-icon-right {
  color: var(--primary-white);
}
.p-selectbutton .p-button.p-highlight:hover {
  background: var(--blue-dark);
  border-color: var(--blue-dark);
  color: var(--primary-white);
}
.p-selectbutton .p-button.p-highlight:hover .p-button-icon-left,
.p-selectbutton .p-button.p-highlight:hover .p-button-icon-right {
  color: var(--primary-white);
}
.p-selectbutton.p-invalid > .p-button {
  border-color: var(--red-100);
}
.p-selectbutton .p-button {
  margin: 0;
}
.p-selectbutton .p-button:not(:last-child) {
  border-right: 0 none;
}
.p-selectbutton .p-button:not(:first-of-type):not(:last-of-type) {
  border-radius: 0;
}
.p-selectbutton .p-button:first-of-type {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.p-selectbutton .p-button:last-of-type {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.p-selectbutton .p-button:focus {
  position: relative;
  z-index: 1;
} */

/* calendar */
.p-calendar {
  position: relative;
  display: inline-flex;
  max-width: 100%;
}
.p-calendar .p-inputtext {
  flex: 1 1 auto;
  width: 1%;
}
.p-calendar-w-btn-right .p-inputtext {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}
.p-calendar-w-btn-right .p-datepicker-trigger {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.p-calendar-w-btn-left .p-inputtext {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
}
.p-calendar-w-btn-left .p-datepicker-trigger {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.p-calendar.p-invalid.p-component > .p-inputtext {
  border-color: var(--red-100);
}

/* inputtext */
.p-inputtext {
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.005rem;
  color: var(--gray-100);
  background: var(--primary-white);
  padding: 11px;
  border: 1px solid var(--gray-20);
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  appearance: none;
  border-radius: 8px;
}
.p-inputtext::placeholder {
  color: var(--gray-50);
}
.p-inputtext.inputtext-sm,
.p-dropdown.dropdown-sm .p-inputtext,
.p-calendar.calendar-sm .p-inputtext {
  padding: 7px 9px;
  border-radius: 6px;
  font-size: 13px;
}
.p-inputtext.inputtext-xs,
.p-dropdown.dropdown-xs .p-inputtext,
.p-calendar.calendar-xs .p-inputtext {
  padding: 7px 6px;
  border-radius: 6px;
  font-size: 11px;
}
.p-autocomplete.autocomplete-sm .p-inputtext {
  padding: 7px 9px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  font-size: 13px;
}
.p-inputtext:enabled:hover {
  color: var(--gray-60);
  border-color: var(--gray-40);
}
.p-inputtext:enabled:focus {
  color: var(--gray-100);
  border-color: var(--blue-100);
  box-shadow: none;
  outline: 0 none;
  outline-offset: 0;
}

/* dropdown */
.p-dropdown {
  color: var(--gray-100);
  border: 1px solid var(--gray-20);
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  border-radius: 8px;
}
.p-dropdown.dropdown-sm {
  border-radius: 6px;
}
.p-dropdown.dropdown-xl {
  border-radius: 10px;
}

.p-dropdown .p-dropdown-label.p-inputtext {
  padding-right: 0;
  border: none;
}
.p-dropdown:not(.p-disabled):hover,
.p-dropdown:not(.p-disabled):hover .p-dropdown-label {
  color: var(--gray-60);
  border-color: var(--gray-40);
}
.p-dropdown:not(.p-disabled).p-focus,
.p-dropdown:not(.p-disabled):focus .p-dropdown-label {
  color: var(--gray-100);
  border-color: var(--blue-100);
  box-shadow: none;
  /* box-shadow: var(--shadow-focus); */
}
.p-autocomplete-dropdown,
.p-dropdown .p-dropdown-trigger {
  color: var(--gray-40);
  width: 34px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.p-dropdown .p-dropdown-clear-icon {
  color: var(--gray-40);
  right: 34px;
}
.p-invalid.p-component,
.p-inputnumber.p-invalid.p-component > .p-inputtext,
.p-autocomplete.p-invalid.p-component > .p-inputtext {
  border-color: var(--red-100) !important;
}
.p-dropdown.no-trigger .p-dropdown-trigger {
  display: none;
}

/* dropdown panel*/
.p-dropdown-panel {
  background-color: var(--primary-white);
  color: var(--gray-80);
  border: 0 none;
  border-radius: 8px;
  box-shadow: var(--shadow-level-2);
}
.p-dropdown-panel .p-dropdown-header {
  padding: 8px 0 4px;
  margin: 0 4px;
  background: none;
  border-bottom: 1px solid var(--gray-10);
}
.p-dropdown-panel .p-dropdown-header .p-dropdown-filter {
  padding-left: 40px;
  padding-right: 0;
  border: 0 none;
}
.p-dropdown-panel .p-dropdown-header .p-dropdown-filter-icon,
.p-dropdown-panel .p-dropdown-header .p-dropdown-filter-clear-icon {
  position: absolute;
  margin: 0;
  top: 12px;
  left: 12px;
  color: var(--gray-60);
}
.p-dropdown-panel .p-dropdown-header .p-dropdown-clearable-filter .p-dropdown-filter {
  padding-right: 48px;
}
.p-dropdown-panel .p-dropdown-header .p-dropdown-clearable-filter .p-dropdown-filter-clear-icon {
  right: 32px;
  cursor: pointer;
}
.p-dropdown-panel .p-dropdown-items {
  padding: 4px;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  background: transparent;
  color: var(--gray-80);
  margin: 0;
  padding: 0 12px;
  border: 0 none;
  border-radius: 8px;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  letter-spacing: 0.005rem;
  height: 40px;
  display: flex;
  align-items: center;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  background-color: var(--blue-4);
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-disabled):hover {
  background-color: var(--gray-1) !important;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-disabled):focus {
  outline: none !important;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item-group {
  margin: 0;
  padding: 6px 12px 2px;
  border: 0 none;
  background: transparent;
  color: var(--gray-60);
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  letter-spacing: -0.01rem;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-empty-message {
  padding: 12px;
  color: var(--gray-80);
  background: transparent;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  letter-spacing: 0.005rem;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item .p-dropdown-item-label {
  width: 100%;
}

/* calendar */
.p-calendar {
  position: relative;
  display: inline-flex;
  max-width: 100%;
}
.p-calendar .p-inputtext {
  flex: 1 1 auto;
  width: 1%;
}
.p-calendar .p-datepicker-trigger {
  width: 40px;
  padding: 0;
}
.p-calendar-w-btn-right .p-inputtext {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: none;
}
.p-calendar-w-btn-right .p-datepicker-trigger {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.p-calendar-w-btn-left .p-inputtext {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-left: none;
}
.p-calendar-w-btn-left .p-datepicker-trigger {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.p-calendar.calendar-sm .p-datepicker-trigger {
  width: 32px;
}

/* checkbox */
.p-checkbox {
  width: 20px;
  height: 20px;
}
.p-checkbox .p-checkbox-box {
  border: 1px solid var(--gray-20);
  background: var(--primary-white);
  width: 20px;
  height: 20px;
  color: var(--gray-40);
  border-radius: 4px;
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
}
.p-checkbox .p-checkbox-box .p-checkbox-icon {
  transition-duration: 0.2s;
  color: var(--primary-white);
  font-size: 14px;
}
.p-checkbox.p-highlight .p-checkbox-box {
  border-color: var(--blue-100);
  background: var(--blue-100);
}
.p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {
  border-color: var(--blue-dark);
  background: var(--blue-dark);
  color: var(--primary-white);
}
.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
  border-color: var(--gray-40);
}
.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: var(--shadow-focus);
  border-color: var(--blue-100);
}
.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
  border-color: var(--blue-dark);
  background: var(--blue-dark);
  color: var(--primary-white);
}
.p-checkbox .p-checkbox-box.p-disabled:not(.p-highlight) {
  border-color: var(--gray-10);
  background: var(--gray-10);
  opacity: 1;
}
.p-checkbox.p-invalid > .p-checkbox-box {
  border-color: var(--red-100);
}

/* datepicker */
.p-datepicker:not(.p-datepicker-inline) {
  background: var(--primary-white);
  border: 0 none;
  border-radius: 8px;
  box-shadow: 0px 4px 22px 0px rgba(14, 36, 59, 0.1);
  transform: translate(10px, -4px);
}

/* avatar */
.p-avatar {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  font-weight: 400;
  font-size: 11px;
  line-height: 12px;
  letter-spacing: 0.01rem;
  background-color: var(--blue-20);
  color: var(--blue-dark);
  overflow: hidden;
}
.p-avatar.p-avatar-lg {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 16px;
}
.p-avatar.p-avatar-xl {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 16px;
}
/* menu */
.p-menu {
  padding: 6px 0;
  background: var(--primary-white);
  color: var(--gray-80);
  border: 0 none;
  border-radius: 8px;
  --menu-width: max-content;
  width: var(--menu-width);
  max-width: 240px;
  min-width: 115px;
}
.p-menu.p-menu-overlay {
  border: 0 none;
  box-shadow: var(--shadow-level-2);
  margin: 4px 0;
}
.p-menu .p-menu-separator {
  border-top: 1px solid var(--gray-20);
  margin: 6px 0;
}
.p-menu .p-menu-item {
  color: var(--gray-80);
  font-size: 13px;
  line-height: 13px;
  font-weight: 400;
}
.p-menu .p-menuitem-link {
  min-height: 40px;
  padding: 12px;
  border: 2px solid var(--primary-white);
  border-left-width: 4px;
  border-right-width: 4px;
  border-radius: 8px;
}
.p-menu .p-menuitem-link:not(.p-disabled):hover {
  background-color: var(--gray-1);
}
.p-menu .p-menuitem-text {
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  letter-spacing: 0.005rem;
}

/* inputgroup */
.p-inputgroup-addon {
  background: var(--primary-white);
  color: var(--gray-60);
  border-top: none;
  border-left: none;
  border-bottom: none;
  padding: 0;
  min-width: 40px;
}
.p-inputgroup-addon:last-child {
  border-right: none;
}
.p-inputgroup.inputgroup-sm .p-inputgroup-addon {
  min-width: 32px;
}
.p-inputgroup.inputgroup-xl .p-inputgroup-addon {
  min-width: 48px;
}

.p-inputgroup > .p-component,
.p-inputgroup > .p-inputwrapper > .p-inputtext,
.p-inputgroup > .p-float-label > .p-component {
  border-radius: 0;
  margin: 0;
}
.p-inputgroup > .p-component + .p-inputgroup-addon,
.p-inputgroup > .p-inputwrapper > .p-inputtext + .p-inputgroup-addon,
.p-inputgroup > .p-float-label > .p-component + .p-inputgroup-addon {
  border-left: 0 none;
}
.p-inputgroup > .p-component:focus,
.p-inputgroup > .p-inputwrapper > .p-inputtext:focus,
.p-inputgroup > .p-float-label > .p-component:focus {
  z-index: 1;
}
.p-inputgroup > .p-component:focus ~ label,
.p-inputgroup > .p-inputwrapper > .p-inputtext:focus ~ label,
.p-inputgroup > .p-float-label > .p-component:focus ~ label {
  z-index: 1;
}

.p-inputgroup-addon:first-child,
.p-inputgroup button:first-child,
.p-inputgroup input:first-child,
.p-inputgroup > .p-inputwrapper:first-child,
.p-inputgroup > .p-inputwrapper:first-child > .p-inputtext {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.p-inputgroup .p-float-label:first-child input {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.p-inputgroup-addon:last-child,
.p-inputgroup button:last-child,
.p-inputgroup input:last-child,
.p-inputgroup > .p-inputwrapper:last-child,
.p-inputgroup > .p-inputwrapper:last-child > .p-inputtext {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.p-inputgroup .p-float-label:last-child input {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.p-inputgroup.inputgroup-sm .p-inputgroup-addon:first-child,
.p-inputgroup.inputgroup-sm button:first-child,
.p-inputgroup.inputgroup-sm input:first-child,
.p-inputgroup.inputgroup-sm > .p-inputwrapper:first-child,
.p-inputgroup.inputgroup-sm > .p-inputwrapper:first-child > .p-inputtext {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.p-inputgroup.inputgroup-sm .p-float-label:first-child input {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.p-inputgroup.inputgroup-sm .p-inputgroup-addon:last-child,
.p-inputgroup.inputgroup-sm button:last-child,
.p-inputgroup.inputgroup-sm input:last-child,
.p-inputgroup.inputgroup-sm > .p-inputwrapper:last-child,
.p-inputgroup.inputgroup-sm > .p-inputwrapper:last-child > .p-inputtext {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.p-inputgroup.inputgroup-sm .p-float-label:last-child input {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.p-inputgroup.inputgroup-xl .p-inputgroup-addon:first-child,
.p-inputgroup.inputgroup-xl button:first-child,
.p-inputgroup.inputgroup-xl input:first-child,
.p-inputgroup.inputgroup-xl > .p-inputwrapper:first-child,
.p-inputgroup.inputgroup-xl > .p-inputwrapper:first-child > .p-inputtext {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.p-inputgroup.inputgroup-xl .p-float-label:first-child input {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.p-inputgroup.inputgroup-xl .p-inputgroup-addon:last-child,
.p-inputgroup.inputgroup-xl button:last-child,
.p-inputgroup.inputgroup-xl input:last-child,
.p-inputgroup.inputgroup-xl > .p-inputwrapper:last-child,
.p-inputgroup.inputgroup-xl > .p-inputwrapper:last-child > .p-inputtext {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.p-inputgroup.inputgroup-xl .p-float-label:last-child input {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.p-fluid .p-inputgroup .p-button {
  width: auto;
}

.p-tabview .p-tabview-nav {
  background: var(--primary-white);
  border: 1px solid var(--gray-20);
  border-width: 0 0 1px 0;
}
.p-tabview .p-tabview-nav li {
  margin-right: 0;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  background: transparent;
  color: var(--gray-60);
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.01rem;
  font-weight: 500;
  border: solid transparent;
  border-width: 0 0 2px 0;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  transition: none;
  padding: 8px 16px;
  margin: 0 0 -1px 0;
  height: 40px;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}
.p-tabview .p-tabview-nav li:not(.p-disabled):hover .p-tabview-nav-link {
  background: var(--gray-1);
}
.p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {
  background: var(--gray-1);
  border-color: transparent;
}
.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: transparent;
  border-color: var(--blue-100);
  color: var(--blue-100);
}
.p-tabview .p-tabview-panels {
  background: transparent;
  padding: 0;
  border: 0 none;
  color: initial;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.p-tabview.tabview-embed {
  display: flex;
  flex-direction: column;
}
.p-tabview.tabview-embed .p-tabview-panels {
  flex-grow: 1;
  height: 0;
}

/* multiselect */
.p-multiselect {
  color: var(--gray-100);
  border: 1px solid var(--gray-20);
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  border-radius: 8px;
}
.p-multiselect:not(.p-disabled):hover {
  color: var(--gray-60);
  border-color: var(--gray-40);
}
.p-multiselect:not(.p-disabled).p-focus {
  color: var(--gray-100);
  border-color: var(--blue-100);
  box-shadow: none;
  outline: 0 none;
  outline-offset: 0;
}
.p-multiselect.p-multiselect-clearable .p-multiselect-label {
  padding-right: 24px;
}
.p-multiselect .p-multiselect-label {
  padding: 12px;
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
}
.p-multiselect .p-multiselect-label.p-placeholder {
  color: var(--gray-50);
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.005rem;
  padding: 12px;
}
.p-multiselect.p-multiselect-chip {
  border-radius: 8px;
  border-color: var(--gray-40);
}
.p-multiselect.p-multiselect-chip .p-multiselect-token {
  height: 40px;
  padding: 8px;
  margin-right: 4px;
  background: var(--gray-1);
  color: var(--gray-100);
  border-radius: 8px;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.005rem;
  font-weight: 500;
}
.p-multiselect.p-multiselect-chip .p-multiselect-token .p-multiselect-token-icon {
  margin-left: 8px;
  color: var(--gray-50);
  font-size: 12px;
}
.p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label {
  padding: 12px;
}
.p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label.p-multiselect-items-label {
  padding: 12px;
}
.p-multiselect .p-multiselect-trigger {
  align-items: flex-start;
  padding: 12px 10px 0 0;
  color: var(--gray-40);
  background: transparent;
  width: 24px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.p-multiselect .p-multiselect-clear-icon {
  color: var(--gray-60);
  right: 24px;
}
.p-multiselect.p-invalid.p-component {
  border-color: var(--red-100);
}
.p-multiselect-panel {
  background: var(--primary-white);
  color: var(--gray-60);
  border: 0 none;
  border-radius: 8px;
  box-shadow: var(--shadow-level-2);
}
.p-multiselect-panel .custom-multiselect-header {
  padding: 4px 4px 0;
}
.p-multiselect-panel .custom-multiselect-header .p-multiselect-filter-container .p-inputtext {
  padding: 12px 12px 12px 44px;
  border-width: 0;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0;
}
.p-multiselect-panel .custom-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {
  left: 12px;
  margin: 0;
  transform: translateY(-50%);
  color: var(--gray-60);
}
.p-multiselect-panel .p-multiselect-header {
  padding: 10px 16px;
  border-bottom: 0 none;
  color: var(--gray-60);
  background: var(--primary-white);
  margin: 0;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container {
  margin: 0 10px;
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-inputtext {
  padding-right: 24px;
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {
  right: 10px;
  color: var(--gray-60);
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-close {
  width: 20px;
  height: 20px;
  color: var(--gray-60);
  border: 0 none;
  background: transparent;
  border-radius: 4px;
  transition:
    background-color 0.2s,
    color 0.2s,
    box-shadow 0.2s;
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-close:enabled:hover {
  color: var(--gray-100);
  border-color: transparent;
  background: var(--gray-1);
}
.p-multiselect-panel .p-multiselect-header .p-multiselect-close:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}
.p-multiselect-panel .p-multiselect-items {
  padding: 4px;
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-item {
  margin: 0;
  padding: 10px 12px;
  border: 0 none;
  color: var(--gray-80);
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 4px;
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-item > span {
  width: 100%;
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
  color: var(--gray-100);
  background: var(--primary-white);
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled):hover {
  color: var(--gray-100);
  background: var(--gray-1);
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-item:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-item .p-checkbox {
  margin-right: 12px;
  pointer-events: none;
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-item-group {
  margin: 0;
  padding: 10px 12px;
  color: var(--gray-60);
  background: var(--primary-white);
  font-weight: 400;
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-empty-message {
  padding: 10px 12px;
  color: var(--gray-50);
  background: transparent;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.005rem;
}

/* multiselect compact chips */
.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-label {
  padding: 4px 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-label.p-placeholder,
.p-inputwrapper-filled.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-label {
  padding: 8px 10px;
}
.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-token {
  height: 24px;
  padding: 2px 6px;
  margin-right: 0;
  font-size: 12px;
  line-height: 12px;
  border-radius: 4px;
  max-width: 100%;
  min-width: 0;
}
.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-token .p-multiselect-token-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.005rem;
  font-weight: 400;
}
.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-token .p-multiselect-token-icon {
  margin-left: 8px;
  color: var(--gray-100);
  cursor: pointer;
  flex-shrink: 0;
}
.p-multiselect.multiselect-compact .p-multiselect-trigger {
  align-items: center;
  padding: 0 10px 0 0;
}

/* input compact */
.p-inputtext.input-compact {
  height: 32px;
  padding: 0 10px;
}

/* multiselect compact panel (no checkboxes, custom header) */
.multiselect-compact-panel .custom-multiselect-header {
  padding: 4px 4px 0;
  border-bottom: 1px solid var(--gray-10);
}
.multiselect-compact-panel .custom-multiselect-header .p-multiselect-filter-container .p-inputtext {
  padding: 12px 12px 12px 40px;
  border-width: 0;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0;
}
.multiselect-compact-panel .custom-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {
  left: 12px;
  margin: 0;
  transform: translateY(-50%);
  color: var(--gray-60);
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.multiselect-compact-panel .p-multiselect-items .p-multiselect-item {
  padding: 0 12px;
  min-height: 40px;
  max-height: 40px;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.005rem;
}
.multiselect-compact-panel .p-multiselect-items .p-multiselect-item:hover {
  background: var(--blue-4);
}
.multiselect-compact-panel .p-multiselect-items .p-multiselect-item > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* inputswitch */
.p-inputswitch {
  width: 40px;
  height: 24px;
}
.p-inputswitch:is(.size-small) {
  width: 36px;
  height: 20px;
}
.p-inputswitch .p-inputswitch-slider {
  background: var(--gray-10);
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  border-radius: 30px;
}
.p-inputswitch .p-inputswitch-slider:before {
  background: var(--primary-white);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  transition-duration: 0.2s;
  margin: -10px 2px 2px 2px;
  left: 0;
  box-shadow: 0px 0px 2px 0px #0000001a;
}
.p-inputswitch:is(.size-small) .p-inputswitch-slider:before {
  width: 16px;
  height: 16px;
  margin: -8px 2px 2px 2px;
}
.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before,
.p-inputswitch.p-highlight .p-inputswitch-slider:before,
.p-inputswitch:is(.size-small).p-inputswitch-checked .p-inputswitch-slider:before,
.p-inputswitch:is(.size-small).p-highlight .p-inputswitch-slider:before {
  transform: translateX(15px);
}
.p-inputswitch.p-focus .p-inputswitch-slider {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0px 0px 0px 4px #deebf9;
}
.p-inputswitch:not(.p-disabled):hover .p-inputswitch-slider {
  background: #dce2ec;
}
.p-inputswitch:is(.p-disabled) .p-inputswitch-slider {
  background: #dce1ec;
}
.p-inputswitch:is(.p-disabled) .p-inputswitch-slider:before {
  background: #f6f7fa;
}
.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider,
.p-inputswitch.p-highlight .p-inputswitch-slider {
  background: var(--blue-100);
}
.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before,
.p-inputswitch.p-highlight .p-inputswitch-slider:before {
  background: var(--primary-white);
}
.p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider,
.p-inputswitch.p-highlight:not(.p-disabled):hover .p-inputswitch-slider {
  background: var(--blue-dark);
}
.p-inputswitch.p-inputswitch-checked:is(.p-disabled) .p-inputswitch-slider,
.p-inputswitch.p-highlight:is(.p-disabled) .p-inputswitch-slider {
  opacity: 50%;
}
.p-inputswitch.p-inputswitch-checked:is(.p-disabled) .p-inputswitch-slider:before,
.p-inputswitch.p-highlight:is(.p-disabled) .p-inputswitch-slider:before {
  background: var(--blue-20);
}

/* dialog */
.p-dialog {
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #0e243b0f;
  border: 0 none;
}
.p-dialog .p-dialog-header {
  border-radius: 8px 8px 0px 0px;
  border-bottom: 1px solid var(--gray-20);
  background: var(--primary-white);
  color: var(--gray-100);
  padding: 20px;
}
.p-dialog .p-dialog-header .p-dialog-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 22px;
}
.p-dialog .p-dialog-header .p-dialog-header-icon {
  width: 20px;
  height: 20px;
  color: var(--gray-60);
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition:
    background-color 0.2s,
    color 0.2s,
    box-shadow 0.2s;
}
.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {
  color: var(--gray-100);
  border-color: transparent;
  background: var(--primary-white);
}
.p-dialog .p-dialog-header .p-dialog-header-icon:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem var(--gray-10);
}
.p-dialog .p-dialog-header .p-dialog-header-icon:last-child {
  margin-right: 0;
}
.p-dialog .p-dialog-content {
  background: var(--primary-white);
  color: var(--gray-100);
  padding: 20px;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
}
.p-dialog .p-dialog-content:last-of-type {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.p-dialog .p-dialog-footer {
  border-top: 1px solid var(--gray-20);
  background: var(--primary-white);
  color: var(--gray-80);
  padding: 12px 20px;
  text-align: left;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  display: flex;
}
.p-dialog .p-dialog-footer button {
  padding: 10px 18px;
  margin: 0;
  width: auto;
  border-radius: 10px;
  min-width: 120px;
  min-height: 48px;
  justify-content: center;
}

/* datepicker */
.p-datepicker {
  padding: 4px;
  background: var(--primary-white);
  color: #4b5563;
  border: 0 none;
  border-radius: 8px;
}
.p-datepicker:not(.p-datepicker-inline) {
  background: var(--primary-white);
  border: 0 none;
  box-shadow: 0px 4px 22px 0px #0e243b1a;
}
.p-datepicker:not(.p-datepicker-inline) .p-datepicker-header {
  background: var(--primary-white);
}
.p-datepicker .p-datepicker-header {
  padding: 4px;
  color: #4b5563;
  background: var(--primary-white);
  font-weight: 600;
  margin: 0;
  border-bottom: 0 none;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.p-datepicker .p-datepicker-header .p-datepicker-prev,
.p-datepicker .p-datepicker-header .p-datepicker-next {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition:
    background-color 0.2s,
    color 0.2s,
    box-shadow 0.2s;
}
.p-datepicker .p-datepicker-header .p-datepicker-prev:enabled:hover,
.p-datepicker .p-datepicker-header .p-datepicker-next:enabled:hover {
  color: #4b5563;
  border-color: transparent;
  background: #e9ecef;
}
.p-datepicker .p-datepicker-header .p-datepicker-prev:focus,
.p-datepicker .p-datepicker-header .p-datepicker-next:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #a6d5fa;
}
.p-datepicker .p-datepicker-header .p-datepicker-title {
  line-height: 2rem;
}
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {
  color: #4b5563;
  transition:
    background-color 0.2s,
    color 0.2s,
    box-shadow 0.2s;
  font-weight: 600;
  padding: 0.5rem;
}
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:enabled:hover,
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:enabled:hover {
  color: #2196f3;
}
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {
  margin-right: 0.5rem;
}
.p-datepicker table {
  font-size: 14px;
  margin: 0.5rem 0;
}
.p-datepicker table th {
  padding: 0;
}
.p-datepicker table th > span {
  width: 42px;
  height: 42px;
}
.p-datepicker table td {
  padding: 4px;
}
.p-datepicker table td > span {
  width: 42px;
  height: 42px;
  border-radius: 6px;
  transition: box-shadow 0.2s;
  border: 1px solid transparent;
}
.p-datepicker table td > span.p-highlight {
  color: #4b5563;
  border-color: var(--blue-100);
  background: var(--primary-white);
}
.p-datepicker table td > span.p-highlight:hover {
  background: var(--gray-1);
}
.p-datepicker table td > span:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  color: var(--blue-100);
  border-color: var(--blue-100);
  background: var(--blue-4);
}
.p-datepicker table td.p-datepicker-today > span {
  background: #d2d5db;
  color: #4b5563;
  border-color: #d2d5db;
}
.p-datepicker table td.p-datepicker-today > span.p-highlight {
  background: #d2d5db;
  border-color: #d2d5db;
}
.p-datepicker .p-datepicker-buttonbar {
  padding: 1rem 0;
  border-top: 1px solid #dee2e6;
}
.p-datepicker .p-datepicker-buttonbar .p-button {
  width: auto;
}
.p-datepicker .p-timepicker {
  border-top: 1px solid #dee2e6;
  padding: 0.5rem;
}
.p-datepicker .p-timepicker button {
  width: 2rem;
  height: 2rem;
  color: #6c757d;
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition:
    background-color 0.2s,
    color 0.2s,
    box-shadow 0.2s;
}
.p-datepicker .p-timepicker button:enabled:hover {
  color: #4b5563;
  border-color: transparent;
  background: #e9ecef;
}
.p-datepicker .p-timepicker button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #a6d5fa;
}
.p-datepicker .p-timepicker button:last-child {
  margin-top: 0.2em;
}
.p-datepicker .p-timepicker span {
  font-size: 1.25rem;
}
.p-datepicker .p-timepicker > div {
  padding: 0 0.5rem;
}
.p-datepicker.p-datepicker-timeonly .p-timepicker {
  border-top: 0 none;
}
.p-datepicker .p-monthpicker {
  margin: 0.5rem 0;
}
.p-datepicker .p-monthpicker .p-monthpicker-month {
  padding: 0.5rem;
  transition: box-shadow 0.2s;
  border-radius: 4px;
}
.p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {
  color: #4b5563;
  background: #e3f2fd;
}
.p-datepicker .p-yearpicker {
  margin: 0.5rem 0;
}
.p-datepicker .p-yearpicker .p-yearpicker-year {
  padding: 0.5rem;
  transition: box-shadow 0.2s;
  border-radius: 4px;
}
.p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight {
  color: #4b5563;
  background: #e3f2fd;
}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group {
  border-left: 1px solid #dee2e6;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  padding-top: 0;
  padding-bottom: 0;
}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:first-child {
  padding-left: 0;
}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {
  padding-right: 0;
  border-left: 0 none;
}
.p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover {
  background: var(--gray-1);
  border-color: var(--gray-1);
}
.p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  color: var(--blue-100);
  border-color: var(--blue-100);
  background: var(--blue-4);
}
.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):not(.p-highlight):hover {
  background: #e9ecef;
}
.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #a6d5fa;
}
.p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):not(.p-highlight):hover {
  background: #e9ecef;
}
.p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #a6d5fa;
}

/* scrollpanel */
.p-scrollpanel {
  width: 100%;
  height: 100%;
}
.p-scrollpanel .p-scrollpanel-bar {
  background: var(--gray-20);
}
.p-scrollpanel .p-scrollpanel-content {
  padding: 0;
}
.p-scrollpanel .p-scrollpanel-content > div {
  max-width: 100vw;
}

/* datatable */
/* .p-datatable .p-paginator-top {
  border-width: 0 0 1px 0;
  border-radius: 14px 14px 0 0;
}
.p-datatable .p-paginator-bottom {
  border-width: 0 0 1px 0;
  border-radius: 0 0 14px 14px;
} */
.p-datatable .p-datatable-header {
  background: var(--primary-white);
  color: var(--gray-60);
  border: 1px solid var(--gray-10);
  border-width: 0 0 1px 0;
  padding: 8px 16px;
  font-weight: 400;
}
.p-datatable .p-datatable-footer {
  background: var(--primary-white);
  color: var(--gray-60);
  border: none;
  border-width: 0;
  padding: 8px 16px;
  font-weight: 400;
}
.p-datatable .p-datatable-thead > tr > th {
  text-align: left;
  padding: 8px;
  border: 1px solid var(--gray-10);
  border-width: 0 0 1px 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.01rem;
  color: var(--gray-60);
  background: var(--primary-white);
}
.p-datatable .p-datatable-thead > tr > th:first-child {
  padding-left: 16px;
}
.p-datatable .p-datatable-thead > tr > th:last-child {
  padding-right: 16px;
}
.p-datatable .p-datatable-tfoot > tr > td {
  text-align: left;
  padding: 8px;
  border: 1px solid var(--gray-10);
  border-width: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.01rem;
  color: var(--gray-60);
  background: var(--primary-white);
}
.p-datatable .p-datatable-tfoot > tr > td:first-child {
  padding-left: 16px;
}
.p-datatable .p-datatable-tfoot > tr > td:last-child {
  padding-right: 16px;
}
.p-datatable .p-sortable-column .p-sortable-column-icon {
  color: var(--gray-100);
  margin-left: 4px;
}
.p-datatable .p-sortable-column .p-sortable-column-badge {
  border-radius: 50%;
  height: 16px;
  min-width: 16px;
  line-height: 16px;
  color: var(--gray-80);
  background: var(--gray-1);
  margin-left: 4px;
}
.p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover {
  background: var(--gray-1);
  color: var(--gray-100);
}
.p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover .p-sortable-column-icon {
  color: var(--gray-100);
}
.p-datatable .p-sortable-column.p-highlight {
  background: var(--primary-white);
  color: var(--gray-100);
}
.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {
  color: var(--gray-100);
}
.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover {
  background: var(--gray-1);
  color: var(--gray-100);
}
.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover .p-sortable-column-icon {
  color: var(--gray-100);
}
.p-datatable .p-sortable-column:focus {
  box-shadow: none;
  outline: 0 none;
}
.p-datatable .p-datatable-tbody > tr {
  background: var(--primary-white);
  color: var(--gray-100);
  transition: box-shadow 0.2s;
  font-weight: 400;
  font-size: 14px;
  line-height: 32px;
}
.p-datatable .p-datatable-tbody > tr > td {
  text-align: left;
  border: 1px solid var(--gray-1);
  border-width: 0 0 1px 0;
  padding: 5px 8px 6px;
}
.p-datatable .p-datatable-tbody > tr > td:first-child {
  padding-left: 16px;
}
.p-datatable .p-datatable-tbody > tr > td:last-child {
  padding-right: 16px;
}
.p-datatable .p-datatable-tbody > tr > td .p-row-toggler,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel {
  width: 32px;
  height: 32px;
  color: var(--gray-60);
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition:
    background-color 0.2s,
    color 0.2s,
    box-shadow 0.2s;
}
.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:enabled:hover,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init:enabled:hover,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save:enabled:hover,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel:enabled:hover {
  color: var(--gray-100);
  border-color: transparent;
  background: var(--gray-1);
}
.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:focus,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init:focus,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save:focus,
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem var(--blue-4);
}
.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save {
  margin-right: 4px;
}
.p-datatable .p-datatable-tbody > tr > td > .p-column-title {
  font-weight: 400;
}
.p-datatable .p-datatable-tbody > tr > td.p-highlight {
  background: var(--gray-1);
  color: var(--gray-100);
}
.p-datatable .p-datatable-tbody > tr.p-highlight {
  background: var(--gray-1);
  color: var(--gray-100);
}
.p-datatable .p-datatable-tbody > tr.p-datatable-dragpoint-top > td {
  box-shadow: inset 0 2px 0 0 var(--blue-4);
}
.p-datatable .p-datatable-tbody > tr.p-datatable-dragpoint-bottom > td {
  box-shadow: inset 0 -2px 0 0 var(--blue-4);
}
.p-datatable.p-datatable-selectable .p-datatable-tbody > tr.p-selectable-row:not(.p-highlight):not(.p-datatable-emptymessage):hover {
  background: var(--gray-1);
  color: var(--gray-100);
}
.p-datatable.p-datatable-selectable .p-datatable-tbody > tr.p-selectable-row:focus {
  outline: 2px solid var(--blue-4);
  outline-offset: -2px;
}
.p-datatable.p-datatable-selectable-cell .p-datatable-tbody > tr.p-selectable-row > td.p-selectable-cell:not(.p-highlight):hover {
  background: var(--gray-1);
  color: var(--gray-100);
}
.p-datatable.p-datatable-selectable-cell .p-datatable-tbody > tr.p-selectable-row > td.p-selectable-cell:focus {
  outline: 2px solid var(--blue-4);
  outline-offset: -2px;
}
.p-datatable.p-datatable-hoverable-rows .p-datatable-tbody > tr:not(.p-highlight):not(.p-datatable-emptymessage):hover {
  background: var(--gray-1);
  color: var(--gray-100);
}
.p-datatable .p-column-resizer-helper {
  background: var(--blue-100);
}
.p-datatable .p-datatable-scrollable-header,
.p-datatable .p-datatable-scrollable-footer {
  background: var(--gray-1);
}
.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-datatable-table > .p-datatable-thead,
.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-datatable-table > .p-datatable-tfoot,
.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-virtualscroller > .p-datatable-table > .p-datatable-thead,
.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-virtualscroller > .p-datatable-table > .p-datatable-tfoot {
  background-color: var(--gray-1);
}
.p-datatable .p-datatable-loading-icon {
  font-size: 20px;
}
.p-datatable.p-datatable-gridlines .p-datatable-header {
  border-width: 1px 1px 0 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-footer {
  border-width: 0 1px 1px 1px;
}
.p-datatable.p-datatable-gridlines .p-paginator-top {
  border-width: 0 1px 0 1px;
}
.p-datatable.p-datatable-gridlines .p-paginator-bottom {
  border-width: 0 1px 1px 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th {
  border-width: 1px 0 1px 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th:last-child {
  border-width: 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr > td {
  border-width: 1px 0 0 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr > td:last-child {
  border-width: 1px 1px 0 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr:last-child > td {
  border-width: 1px 0 1px 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr:last-child > td:last-child {
  border-width: 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-tfoot > tr > td {
  border-width: 1px 0 1px 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-tfoot > tr > td:last-child {
  border-width: 1px 1px 1px 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-thead + .p-datatable-tfoot > tr > td {
  border-width: 0 0 1px 1px;
}
.p-datatable.p-datatable-gridlines .p-datatable-thead + .p-datatable-tfoot > tr > td:last-child {
  border-width: 0 1px 1px 1px;
}
.p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody > tr > td {
  border-width: 0 0 1px 1px;
}
.p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody > tr > td:last-child {
  border-width: 0 1px 1px 1px;
}
.p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody > tr:last-child > td {
  border-width: 0 0 0 1px;
}
.p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody > tr:last-child > td:last-child {
  border-width: 0 1px 0 1px;
}
.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd {
  background: var(--blue-4);
}
.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.p-highlight {
  background: #e3f2fd;
  color: var(--gray-100);
}
.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.p-highlight .p-row-toggler {
  color: var(--gray-60);
}
.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.p-highlight .p-row-toggler:hover {
  color: var(--gray-60);
}
.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd + .p-row-expanded {
  background: var(--gray-1);
}
.p-datatable .p-datatable-tbody > tr > td {
  text-align: left;
  border: 1px solid var(--gray-1);
  border-width: 0 0 1px 0;
  padding: 6px 8px 5px;
}
.p-datatable .p-datatable-tbody > tr > td:first-child {
  padding-left: 16px;
}
.p-datatable .p-datatable-tbody > tr > td:last-child {
  padding-right: 16px;
}
.p-datatable.p-datatable-sm .p-datatable-header {
  padding: 8px;
}
.p-datatable.p-datatable-sm .p-datatable-thead > tr > th {
  padding: 8px;
}
.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  padding: 1px 8px 2px;
}
.p-datatable.p-datatable-sm .p-datatable-tfoot > tr > td {
  padding: 8px;
}
.p-datatable.p-datatable-sm .p-datatable-footer {
  padding: 8px;
}
.p-datatable.p-datatable-lg .p-datatable-header {
  padding: 12px;
}
.p-datatable.p-datatable-lg .p-datatable-thead > tr > th {
  padding: 12px;
}
.p-datatable.p-datatable-lg .p-datatable-tbody > tr > td {
  padding: 11px 8px 12px;
}
.p-datatable.p-datatable-lg .p-datatable-tfoot > tr > td {
  padding: 12px;
}
.p-datatable.p-datatable-lg .p-datatable-footer {
  padding: 12px;
}
.p-datatable-drag-selection-helper {
  background: rgba(33, 150, 243, 0.16);
}
.p-selection-column .p-checkbox {
  vertical-align: middle;
}

/* accordion */
.p-accordion .p-accordion-header .p-accordion-header-link {
  padding: 0;
  border: none;
  color: var(--gray-60);
  background: transparent;
  font-weight: 400;
  border-radius: 8px;
}
.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
  display: none;
}
.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-header-text {
  width: 100%;
}
.p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}
.p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {
  background: var(--gray-1);
  color: var(--gray-60);
}
.p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
  background: transparent;
  color: var(--gray-60);
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.p-accordion:not(.accordion-separate-header) .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.p-accordion .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {
  background: var(--gray-1);
  color: var(--gray-60);
}
.p-accordion .p-accordion-content {
  padding: 0;
  border: none;
  background: transparent;
  color: var(--gray-100);
  border-top: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.p-accordion .p-accordion-tab {
  margin-bottom: 0;
}
.p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
  border-radius: 0;
}
.p-accordion .p-accordion-tab .p-accordion-content {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header .p-accordion-header-link {
  border-top: 0 none;
}
.p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link,
.p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {
  border-top: 0 none;
}
.p-accordion .p-accordion-tab:first-child .p-accordion-header .p-accordion-header-link {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.p-accordion .p-accordion-tab:last-child .p-accordion-header:not(.p-highlight) .p-accordion-header-link {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.p-accordion .p-accordion-tab:last-child .p-accordion-header:not(.p-highlight) .p-accordion-content {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

/* sidebar */
.p-sidebar {
  background: var(--primary-white);
  color: var(--gray-1);
  border: 0 none;
  box-shadow: var(--shadow-level-2);
}
.p-sidebar .p-sidebar-header {
  padding: 1rem;
}
.p-sidebar .p-sidebar-header .p-sidebar-close,
.p-sidebar .p-sidebar-header .p-sidebar-icon {
  width: 2rem;
  height: 2rem;
  color: var(--gray-60);
  border: 0 none;
  background: transparent;
  border-radius: 50%;
  transition:
    background-color 0.2s,
    color 0.2s,
    box-shadow 0.2s;
}
.p-sidebar .p-sidebar-header .p-sidebar-close:enabled:hover,
.p-sidebar .p-sidebar-header .p-sidebar-icon:enabled:hover {
  color: var(--gray-80);
  border-color: transparent;
  background: var(--gray-10);
}
.p-sidebar .p-sidebar-header .p-sidebar-close:focus,
.p-sidebar .p-sidebar-header .p-sidebar-icon:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: var(--shadow-focus);
}
.p-sidebar .p-sidebar-header + .p-sidebar-content {
  padding-top: 0;
}
.p-sidebar .p-sidebar-content {
  padding: 1rem;
}

/* tooltip */
.p-tooltip .p-tooltip-text {
  background: var(--primary-white);
  color: var(--gray-100);
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.005rem;
  padding: 8px 12px;
  box-shadow: var(--shadow-level-3);
  border-radius: 4px;
}
.p-tooltip .p-tooltip-arrow {
  display: none;
}

/* icon field */
.p-icon-field {
  position: relative;
}
.p-icon-field-left > .p-inputtext,
.p-icon-field-left > .p-input-icon + .p-autocomplete .p-inputtext {
  padding-left: 38px;
}
.p-icon-field-left.p-float-label > label {
  left: 38px;
}
.p-icon-field-right > .p-inputtext,
.p-icon-field-right > .p-autocomplete .p-inputtext {
  padding-right: 38px;
}
.p-icon-field-left.icon-field-sm > .p-inputtext,
.p-icon-field-left.icon-field-sm > .p-input-icon + .p-autocomplete .p-inputtext {
  padding-left: 32px;
}
.p-icon-field-left.icon-field-sm.p-float-label > label {
  left: 32px;
}
.p-icon-field-right.icon-field-sm > .p-inputtext,
.p-icon-field-right.icon-field-sm > .p-autocomplete .p-inputtext {
  padding-right: 32px;
}
.p-icon-field > .p-input-icon {
  position: absolute;
  width: 16px;
  height: 16px;
  stroke-width: 2.25;
  top: 50%;
  margin-top: -8px;
  color: var(--gray-50);
  z-index: 10;
}
.p-fluid .p-icon-field-left,
.p-fluid .p-icon-field-right {
  width: 100%;
}
.p-icon-field-left > .p-input-icon:first-of-type {
  left: 12px;
}
.p-icon-field-right > .p-input-icon:last-of-type {
  right: 12px;
}
.p-icon-field-left.icon-field-sm > .p-input-icon:first-of-type {
  left: 9px;
}
.p-icon-field-right.icon-field-sm > .p-input-icon:last-of-type {
  right: 9px;
}
.p-icon-field-right.p-dropdown.icon-field-sm > .p-input-icon:last-of-type {
  right: 32px;
}
.p-autocomplete.p-autocomplete-dd .p-autocomplete-loader {
  right: 38px;
}

/* autocomplete */
.p-autocomplete {
  display: inline-flex;
  position: relative;
}
.p-autocomplete-loader {
  position: absolute;
  top: 50%;
  margin-top: -0.5rem;
}
.p-autocomplete-item {
  text-overflow: ellipsis;
  overflow-x: clip;
  white-space: nowrap;
}
.p-autocomplete .p-autocomplete-input {
  flex: 1 1 auto;
  width: 1%;
}
.p-autocomplete-dd .p-autocomplete-input,
.p-autocomplete-dd .p-autocomplete-multiple-container {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}
.p-autocomplete-dd .p-autocomplete-dropdown {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0px;
  border-left: none;
}
.p-autocomplete-dd .p-autocomplete-dropdown,
.p-autocomplete-dd .p-autocomplete-dropdown:hover {
  background: white;
  border-color: var(--gray-20);
}
.p-inputtext:enabled:hover + .p-autocomplete-dropdown {
  border-color: var(--gray-40);
}
.p-autocomplete-input:focus + .p-autocomplete-dropdown {
  border-color: var(--blue-100) !important;
}
.p-autocomplete.p-invalid.p-component > .p-inputtext ~ .p-autocomplete-dropdown {
  border-color: var(--red-100) !important;
}
.p-autocomplete.autocomplete-sm .p-button.p-button-icon-only {
  width: 32px;
  padding: 6px 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

/* messages */
.p-message .p-message-wrapper {
  padding: 0.5rem 1rem;
}
.p-message:first-child {
  margin-top: 0;
}
.p-message:first-child:last-child {
  margin-bottom: 0;
}

/* overlaypanel */
.p-overlaypanel {
  background: var(--primary-white);
  border: 0 none;
  border-radius: 8px;
  box-shadow: var(--shadow-level-3);
}
.p-overlaypanel .p-overlaypanel-content {
  padding: 0;
  height: 100%;
}
.p-overlaypanel .p-overlaypanel-close {
  background: var(--blue-100);
  color: var(--primary-white);
  width: 20px;
  height: 20px;
  transition:
    background-color 0.2s,
    color 0.2s,
    box-shadow 0.2s;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -10px;
}
.p-overlaypanel .p-overlaypanel-close:enabled:hover {
  background: var(--blue-100);
  color: var(--primary-white);
}
.p-overlaypanel:after,
.p-overlaypanel:before {
  display: none;
}
.p-overlaypanel-flipped {
  margin: 0;
  transform: translate(-240px, 12px);
}

.p-toast .p-toast-message-icon {
  width: 28px;
  height: 28px;
}

/* radiobutton */
.p-radiobutton {
  width: 20px;
  height: 20px;
}
.p-radiobutton .p-radiobutton-box {
  width: 20px;
  height: 20px;
  /* color: #495057; */
  border-radius: 50%;
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
}
.p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
  border-color: var(--blue-100);
}
.p-radiobutton .p-radiobutton-box:not(.p-disabled).p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: var(--shadow-focus);
  border-color: var(--blue-100);
}
.p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
  width: 8px;
  height: 8px;
  transition-duration: 0.2s;
  background-color: var(--primary-white);
}
.p-radiobutton .p-radiobutton-box.p-highlight {
  border-color: var(--blue-100);
  background: var(--blue-100);
}
.p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
  border-color: var(--blue-dark);
  background: var(--blue-dark);
  color: var(--primary-white);
}
.p-radiobutton.p-invalid > .p-radiobutton-box {
  border-color: var(--red-100);
}
.p-radiobutton:focus {
  outline: 0 none;
}

.p-input-filled .p-radiobutton .p-radiobutton-box {
  background-color: var(--gray-1);
}
.p-input-filled .p-radiobutton .p-radiobutton-box:not(.p-disabled):hover {
  background-color: var(--gray-1);
}
.p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight {
  background: var(--blue-100);
}
.p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
  background: var(--blue-dark);
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/css/sumo.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;;EAEpC,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,mCAAmC;EACnC,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,kBAAkB;EAClB,4BAA4B;;EAE5B,iBAAiB;EACjB,2BAA2B;;EAE3B,wBAAwB;EACxB,wBAAwB;EACxB,sCAAsC;EACtC,iCAAiC;EACjC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;AACA;;EAEE,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,4GAA4G;AAC9G;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,8DAA8D;EAC9D,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,iBAAiB;EACjB;;;;mBAIiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;;EAEE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,sCAAsC;EACtC,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;;;;EAIE,+BAA+B;EAC/B,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,qCAAqC;AACvC;AACA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;;EAIE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;;;;;EAKE,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA,oBAAoB;AACpB;EACE,sBAAsB;AACxB;AACA;;;;;EAKE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;;;;;;;;EAQE,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;;;;;;;;EAQE,yCAAyC;AAC3C;AACA;;;;;;;;EAQE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;;;;EAIE,6BAA6B;EAC7B,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;;;;;;;;EAQE,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;;;;;;EAQE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;;;;EAIE,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;;;;;;;EAQE,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;;;;;;;;EAQE,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;;;;;EAKE,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;;;;;EAKE,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;;;;EAIE,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;;;;;;;;EAQE,2BAA2B;EAC3B,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;;;;;;;;EAQE,2CAA2C;AAC7C;AACA;;;;;;;;EAQE,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;;;;EAIE,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B;AAChC;AACA;;;;;;;;EAQE,gCAAgC;EAChC,wBAAwB;EACxB,+BAA+B;AACjC;AACA;;;;;;;;EAQE,0BAA0B;EAC1B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;;;;EAIE,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;;;;;;;EAQE,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;;;;;;;;EAQE,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB;;;;mBAIiB;AACnB;AACA;;EAEE,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiEG;;AAEH,aAAa;AACb;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,gCAAgC;EAChC;;;;mBAIiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,gCAAgC;EAChC;;;;mBAIiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;;EAEE,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,qCAAqC;AACvC;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;;;EAGE,uCAAuC;AACzC;AACA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;EACtC,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB;;;;mBAIiB;AACnB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA,SAAS;AACT;EACE,cAAc;EACd,gCAAgC;EAChC,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;AACX;AACA;;;EAGE,mBAAmB;AACrB;AACA;;;EAGE,UAAU;AACZ;AACA;;;EAGE,UAAU;AACZ;;AAEA;;;;;EAKE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;;;;EAKE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;;;;EAKE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;;;;EAKE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;;;;EAKE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;;;;;EAKE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,cAAc;EACd,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,gCAAgC;EAChC;;;;mBAIiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb;;;;mBAIiB;AACnB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;EAChC,SAAS;EACT,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB;;;mBAGiB;AACnB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B;;;;mBAIiB;EACjB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,OAAO;EACP,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;AACA;;;;EAIE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB;;;mBAGiB;AACnB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB;;;mBAGiB;AACnB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd;;;mBAGiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB;;;mBAGiB;AACnB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;;AAEA,cAAc;AACd;;;;;;;GAOG;AACH;EACE,gCAAgC;EAChC,qBAAqB;EACrB,gCAAgC;EAChC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;;;EAIE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB;;;mBAGiB;AACnB;AACA;;;;EAIE,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;;EAIE,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;;EAIE,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,oCAAoC;AACtC;AACA;EACE,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,oBAAoB;EACpB,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB;;;mBAGiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;;EAEE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,cAAc;EACd,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ;;;mBAGiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;;EAEE,aAAa;AACf;AACA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB;;;;mBAIiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B","sourcesContent":[":root {\n  --font-family: 'Poppins', sans-serif;\n\n  /* Blue (Palatinate Blue) */\n  --blue-dark: #1C25A6;\n  --blue-100: #232ED1;\n  --blue-90: #3943D6;\n  --blue-80: #4F58DA;\n  --blue-70: #656DDF;\n  --blue-60: #7B82E3;\n  --blue-50: #9196E8;\n  --blue-40: #A7ABED;\n  --blue-30: #BDC0F1;\n  --blue-20: #D3D5F6;\n  --blue-10: #E9EAFA;\n  --blue-8: #EDEEFB;\n  --blue-4: #F6F7FD;\n  --blue-1: #FDFDFF;\n\n  /* Slate Blue (Medium Slate Blue) */\n  --slate-blue-dark: #5229FF;\n  --slate-blue-100: #7A5AFF;\n  --slate-blue-90: #876BFF;\n  --slate-blue-80: #957BFF;\n  --slate-blue-70: #A28BFF;\n  --slate-blue-60: #AF9CFF;\n  --slate-blue-50: #BCACFF;\n  --slate-blue-40: #CABDFF;\n  --slate-blue-30: #D7CDFF;\n  --slate-blue-20: #E4DEFF;\n  --slate-blue-10: #F2EEFF;\n  --slate-blue-8: #F4F2FF;\n  --slate-blue-4: #FAF8FF;\n  --slate-blue-1: #FEFDFF;\n\n  /* Butterscotch */\n  --butterscotch-dark: #BB7D25;\n  --butterscotch-100: #D8973C;\n  --butterscotch-90: #DCA150;\n  --butterscotch-80: #E0AC63;\n  --butterscotch-70: #E4B677;\n  --butterscotch-60: #E8C18A;\n  --butterscotch-50: #EBCB9D;\n  --butterscotch-40: #EFD5B1;\n  --butterscotch-30: #F3E0C4;\n  --butterscotch-20: #F7EAD8;\n  --butterscotch-10: #FBF5EB;\n  --butterscotch-8: #FCF7EF;\n  --butterscotch-4: #FDFBF7;\n  --butterscotch-1: #FFFEFD;\n\n  /* Green (Sea Green) */\n  --green-dark: #115A38;\n  --green-100: #198754;\n  --green-90: #309365;\n  --green-80: #479F76;\n  --green-70: #5EAB87;\n  --green-60: #75B798;\n  --green-50: #8CC3A9;\n  --green-40: #A3CFBB;\n  --green-30: #BADBCC;\n  --green-20: #D1E7DD;\n  --green-10: #E8F3EE;\n  --green-8: #EDF5F1;\n  --green-4: #F6FAF8;\n  --green-1: #FDFEFD;\n\n  /* Red (Chili Red) */\n  --red-dark: #B23724;\n  --red-100: #D64933;\n  --red-90: #DA5B47;\n  --red-80: #DE6D5C;\n  --red-70: #E28070;\n  --red-60: #E69285;\n  --red-50: #EBA499;\n  --red-40: #EFB6AD;\n  --red-30: #F3C8C2;\n  --red-20: #F7DBD6;\n  --red-10: #FBEDEB;\n  --red-8: #FCF0EF;\n  --red-4: #FDF8F7;\n  --red-1: #FFFDFD;\n\n  /* Gray (Text) */\n  --gray-100: #061437;\n  --gray-90: #1F2C4B;\n  --gray-80: #38435F;\n  --gray-70: #515B73;\n  --gray-60: #6A7287;\n  --gray-50: #82899B;\n  --gray-40: #9BA1AF;\n  --gray-30: #B4B8C3;\n  --gray-20: #CDD0D7;\n  --gray-10: #E6E7EB;\n  --gray-8: #EBECEF;\n  --gray-4: #F5F6F7;\n  --gray-1: #FDFDFD;\n\n  /* Deep Sky Blue */\n  --deep-sky-blue-100: #02BBFF;\n\n  /* Bright Peony */\n  --bright-peony-100: #F26DF9;\n\n  --primary-white: #ffffff;\n  --primary-black: #000000;\n  --primary-white-transparent: #ffffff99;\n  --shadow-focus: 0 0 0 4px #D3D5F6;\n  --shadow-level-1: 0 4px 16px 0 #0e243b0f;\n  --shadow-level-2: 0 4px 22px 0 #0e243b1a;\n  --shadow-level-3: 0 5px 26px 0 #0e243b26;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n  font-size: 16px;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-family);\n  font-weight: 400;\n  color: var(--gray-100);\n  padding: 0;\n  margin: 0;\n  min-height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  color: var(--blue-100);\n}\na:hover {\n  color: var(--blue-dark);\n}\n\n.p-component {\n  font-family: var(--font-family);\n}\n.p-disabled,\n.p-component:disabled {\n  opacity: 0.6;\n}\n.p-component-overlay {\n  background-color: rgba(0, 0, 0, 0.4);\n  transition-duration: 0.2s;\n}\n\n/* spinner */\n.p-progress-spinner-circle {\n  stroke: var(--gray-40);\n  animation: p-progress-spinner-dash 1.5s ease-in-out infinite;\n}\n\n/* skeleton */\n.p-skeleton {\n  background-color: var(--gray-10);\n  border-radius: 4px;\n}\n.p-skeleton:after {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0));\n}\n\n/* layout mask */\n.layout-mask {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 998;\n  width: 100%;\n  height: 100%;\n  animation-duration: 0.4s;\n  animation-timing-function: cubic-bezier(0.05, 0.74, 0.2, 0.99);\n  animation-fill-mode: forwards;\n}\n\n/* button */\n.p-button {\n  color: var(--primary-white);\n  background: var(--blue-100);\n  border: 1px solid var(--blue-100);\n  padding: 9px 17px;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  letter-spacing: 0.01rem;\n}\n.p-button.button-sm {\n  padding: 7px 12px;\n  border-radius: 6px;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 16px;\n  letter-spacing: 0.01rem;\n}\n.p-button:enabled:hover,\n.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: var(--blue-dark);\n  border-color: var(--blue-dark);\n}\n.p-button:focus {\n  box-shadow: var(--shadow-focus);\n}\n.p-button .p-button-label {\n  font-weight: 500;\n  transition-duration: 0s;\n}\n.p-button.button-sm .p-button-label {\n  font-weight: 400;\n}\n.p-button.p-button-icon-only {\n  width: 38px;\n  padding: 9px 0;\n}\n\n/* link button */\n.p-button.p-button-link {\n  background: inherit;\n  border: inherit;\n  color: inherit;\n}\n.p-button.p-button-link:enabled:hover,\n.p-button.p-button-link:not(button):not(a):not(.p-disabled):hover {\n  background: inherit;\n  border-color: inherit;\n}\n.p-button.p-button-link:focus {\n  box-shadow: inherit;\n}\n\n/* button and icon sizes */\n.p-button.button-xl {\n  padding: 14px 17px;\n  border-radius: 10px;\n}\n.p-button.button-icon {\n  padding: 9px;\n}\n.p-button.button-icon-xl {\n  padding: 6px;\n}\n.p-button.button-icon.button-xl {\n  padding: 14px;\n}\n.p-button.button-icon-xl.button-xl {\n  padding: 11px;\n}\n\n/* button tomato*/\n.p-button.button-tomato {\n  background: var(--red-100);\n  border: 1px solid var(--red-100);\n}\n.p-button.button-tomato:enabled:hover,\n.p-button.button-tomato:not(button):not(a):not(.p-disabled):hover {\n  background: var(--red-dark);\n  border-color: var(--red-dark);\n}\n\n/* button outlined */\n.p-button.p-button-outlined {\n  background-color: var(--primary-white);\n  color: var(--gray-60);\n  border-color: var(--gray-20);\n}\n.p-button.p-button-outlined.button-xl {\n  color: var(--gray-80);\n}\n.p-button.p-button-outlined:enabled:hover,\n.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-button.p-button-outlined:enabled:active,\n.p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background-color: var(--gray-1);\n  color: var(--gray-100);\n  border-color: var(--gray-100);\n}\n.p-button.p-button-outlined:focus {\n  box-shadow: 0px 0px 0px 4px #676e7629;\n}\n/* button outlined blue*/\n.p-button.p-button-outlined.button-blue {\n  color: var(--blue-100);\n  border-color: var(--blue-100);\n}\n.p-button.p-button-outlined.button-blue:enabled:hover,\n.p-button.p-button-outlined.button-blue:not(button):not(a):not(.p-disabled):hover,\n.p-button.p-button-outlined.button-blue:enabled:active,\n.p-button.p-button-outlined.button-blue:not(button):not(a):not(.p-disabled):active {\n  color: var(--blue-dark);\n  border-color: var(--blue-dark);\n}\n\n/* button text */\n.p-button.p-button-text {\n  background-color: transparent;\n  color: var(--gray-80);\n  border-color: transparent;\n  padding: 0;\n}\n.p-button.p-button-text.button-xl {\n  font-size: 15px;\n}\n.p-button.p-button-text:enabled:hover,\n.p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-button.p-button-text:enabled:active,\n.p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-button.p-button-text:focus {\n  background-color: transparent;\n  color: var(--gray-100);\n  border-color: transparent;\n  box-shadow: none;\n}\n/* button text blue*/\n.p-button.p-button-text.button-blue {\n  color: var(--blue-100);\n}\n.p-button.p-button-text.button-blue:enabled:hover,\n.p-button.p-button-text.button-blue:not(button):not(a):not(.p-disabled):hover,\n.p-button.p-button-text.button-blue:enabled:active,\n.p-button.p-button-text.button-blue:not(button):not(a):not(.p-disabled):active,\n.p-button.p-button-text.button-blue:focus {\n  color: var(--blue-dark);\n}\n\n/* button severity danger */\n.p-button.p-button-danger,\n.p-buttonset.p-button-danger > .p-button,\n.p-splitbutton.p-button-danger > .p-button,\n.p-fileupload-choose.p-button-danger {\n  color: var(--red-100);\n  background: var(--red-20);\n  border: 1px solid var(--red-20);\n}\n.p-button.p-button-danger:enabled:hover,\n.p-button.p-button-danger:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-danger > .p-button:enabled:hover,\n.p-buttonset.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-danger > .p-button:enabled:hover,\n.p-splitbutton.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-danger:enabled:hover,\n.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):hover {\n  background: var(--red-20);\n  color: var(--red-dark);\n  border-color: var(--red-20);\n}\n.p-button.p-button-danger:enabled:focus,\n.p-button.p-button-danger:not(button):not(a):not(.p-disabled):focus,\n.p-buttonset.p-button-danger > .p-button:enabled:focus,\n.p-buttonset.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):focus,\n.p-splitbutton.p-button-danger > .p-button:enabled:focus,\n.p-splitbutton.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):focus,\n.p-fileupload-choose.p-button-danger:enabled:focus,\n.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):focus {\n  box-shadow: 0px 0px 0px 4px var(--red-20);\n}\n.p-button.p-button-danger:enabled:active,\n.p-button.p-button-danger:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-danger > .p-button:enabled:active,\n.p-buttonset.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-danger > .p-button:enabled:active,\n.p-splitbutton.p-button-danger > .p-button:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-danger:enabled:active,\n.p-fileupload-choose.p-button-danger:not(button):not(a):not(.p-disabled):active {\n  background: var(--red-20);\n  color: var(--red-100);\n  border-color: var(--red-20);\n}\n.p-button.p-button-danger.p-button-outlined,\n.p-buttonset.p-button-danger > .p-button.p-button-outlined,\n.p-splitbutton.p-button-danger > .p-button.p-button-outlined,\n.p-fileupload-choose.p-button-danger.p-button-outlined {\n  background-color: transparent;\n  color: var(--red-100);\n  border-color: var(--red-100);\n}\n.p-button.p-button-danger.p-button-outlined:enabled:hover,\n.p-button.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-danger > .p-button.p-button-outlined:enabled:hover,\n.p-buttonset.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-danger > .p-button.p-button-outlined:enabled:hover,\n.p-splitbutton.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-danger.p-button-outlined:enabled:hover,\n.p-fileupload-choose.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):hover {\n  background-color: var(--red-4);\n  color: var(--red-dark);\n  border-color: var(--red-dark);\n}\n.p-button.p-button-danger.p-button-outlined:enabled:active,\n.p-button.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-danger > .p-button.p-button-outlined:enabled:active,\n.p-buttonset.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-danger > .p-button.p-button-outlined:enabled:active,\n.p-splitbutton.p-button-danger > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-danger.p-button-outlined:enabled:active,\n.p-fileupload-choose.p-button-danger.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background: var(--red-4);\n  color: var(--red-dark);\n  border-color: var(--red-4);\n}\n.p-button.p-button-danger.p-button-text,\n.p-buttonset.p-button-danger > .p-button.p-button-text,\n.p-splitbutton.p-button-danger > .p-button.p-button-text,\n.p-fileupload-choose.p-button-danger.p-button-text {\n  background-color: transparent;\n  color: var(--red-100);\n  border-color: transparent;\n}\n.p-button.p-button-danger.p-button-text:enabled:hover,\n.p-button.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-danger > .p-button.p-button-text:enabled:hover,\n.p-buttonset.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-danger > .p-button.p-button-text:enabled:hover,\n.p-splitbutton.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-danger.p-button-text:enabled:hover,\n.p-fileupload-choose.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):hover {\n  background-color: transparent;\n  color: var(--red-dark);\n  border-color: transparent;\n}\n.p-button.p-button-danger.p-button-text:enabled:active,\n.p-button.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-danger > .p-button.p-button-text:enabled:active,\n.p-buttonset.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-danger > .p-button.p-button-text:enabled:active,\n.p-splitbutton.p-button-danger > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-danger.p-button-text:enabled:active,\n.p-fileupload-choose.p-button-danger.p-button-text:not(button):not(a):not(.p-disabled):active {\n  background-color: transparent;\n  color: var(--red-dark);\n  border-color: transparent;\n}\n\n/* add button */\n.p-button.button-add {\n  background: var(--gray-1);\n  border-color: var(--gray-1);\n  color: var(--gray-50);\n  border-radius: 4px;\n  height: 16px;\n  padding: 0;\n}\n.p-button.button-add:enabled:hover,\n.p-button.button-add:not(button):not(a):not(.p-disabled):hover,\n.p-button.button-add:enabled:active,\n.p-button.button-add:not(button):not(a):not(.p-disabled):active,\n.p-button.button-add:focus {\n  background: var(--blue-20);\n  border-color: var(--blue-20);\n  color: var(--blue-100);\n  box-shadow: none;\n}\n.p-button.p-button-text.button-secondary {\n  color: var(--gray-50);\n}\n.p-button.p-button-text.button-secondary:enabled:hover,\n.p-button.p-button-text.button-secondary:not(button):not(a):not(.p-disabled):hover,\n.p-button.p-button-text.button-secondary:enabled:active,\n.p-button.p-button-text.button-secondary:not(button):not(a):not(.p-disabled):active,\n.p-button.p-button-text.button-secondary:focus {\n  color: var(--gray-80);\n}\n\n/* button severity success */\n.p-button.p-button-success,\n.p-buttonset.p-button-success > .p-button,\n.p-splitbutton.p-button-success > .p-button,\n.p-fileupload-choose.p-button-success {\n  color: var(--green-100);\n  background: var(--green-20);\n  border: 1px solid var(--green-20);\n}\n.p-button.p-button-success:enabled:hover,\n.p-button.p-button-success:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-success > .p-button:enabled:hover,\n.p-buttonset.p-button-success > .p-button:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-success > .p-button:enabled:hover,\n.p-splitbutton.p-button-success > .p-button:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-success:enabled:hover,\n.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):hover {\n  background: var(--green-20);\n  color: var(--green-dark);\n  border-color: var(--green-20);\n}\n.p-button.p-button-success:enabled:focus,\n.p-button.p-button-success:not(button):not(a):not(.p-disabled):focus,\n.p-buttonset.p-button-success > .p-button:enabled:focus,\n.p-buttonset.p-button-success > .p-button:not(button):not(a):not(.p-disabled):focus,\n.p-splitbutton.p-button-success > .p-button:enabled:focus,\n.p-splitbutton.p-button-success > .p-button:not(button):not(a):not(.p-disabled):focus,\n.p-fileupload-choose.p-button-success:enabled:focus,\n.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):focus {\n  box-shadow: 0px 0px 0px 4px var(--green-20);\n}\n.p-button.p-button-success:enabled:active,\n.p-button.p-button-success:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-success > .p-button:enabled:active,\n.p-buttonset.p-button-success > .p-button:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-success > .p-button:enabled:active,\n.p-splitbutton.p-button-success > .p-button:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-success:enabled:active,\n.p-fileupload-choose.p-button-success:not(button):not(a):not(.p-disabled):active {\n  background: var(--green-20);\n  color: var(--green-100);\n  border-color: var(--green-20);\n}\n.p-button.p-button-success.p-button-outlined,\n.p-buttonset.p-button-success > .p-button.p-button-outlined,\n.p-splitbutton.p-button-success > .p-button.p-button-outlined,\n.p-fileupload-choose.p-button-success.p-button-outlined {\n  background-color: transparent;\n  color: var(--green-100);\n  border-color: var(--green-100);\n}\n.p-button.p-button-success.p-button-outlined:enabled:hover,\n.p-button.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-success > .p-button.p-button-outlined:enabled:hover,\n.p-buttonset.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-success > .p-button.p-button-outlined:enabled:hover,\n.p-splitbutton.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-success.p-button-outlined:enabled:hover,\n.p-fileupload-choose.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):hover {\n  background-color: var(--green-4);\n  color: var(--green-dark);\n  border-color: var(--green-dark);\n}\n.p-button.p-button-success.p-button-outlined:enabled:active,\n.p-button.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-success > .p-button.p-button-outlined:enabled:active,\n.p-buttonset.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-success > .p-button.p-button-outlined:enabled:active,\n.p-splitbutton.p-button-success > .p-button.p-button-outlined:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-success.p-button-outlined:enabled:active,\n.p-fileupload-choose.p-button-success.p-button-outlined:not(button):not(a):not(.p-disabled):active {\n  background: var(--green-4);\n  color: var(--green-dark);\n  border-color: var(--green-4);\n}\n.p-button.p-button-success.p-button-text,\n.p-buttonset.p-button-success > .p-button.p-button-text,\n.p-splitbutton.p-button-success > .p-button.p-button-text,\n.p-fileupload-choose.p-button-success.p-button-text {\n  background-color: transparent;\n  color: var(--green-100);\n  border-color: transparent;\n}\n.p-button.p-button-success.p-button-text:enabled:hover,\n.p-button.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-buttonset.p-button-success > .p-button.p-button-text:enabled:hover,\n.p-buttonset.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-splitbutton.p-button-success > .p-button.p-button-text:enabled:hover,\n.p-splitbutton.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):hover,\n.p-fileupload-choose.p-button-success.p-button-text:enabled:hover,\n.p-fileupload-choose.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):hover {\n  background-color: transparent;\n  color: var(--green-dark);\n  border-color: transparent;\n}\n.p-button.p-button-success.p-button-text:enabled:active,\n.p-button.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-buttonset.p-button-success > .p-button.p-button-text:enabled:active,\n.p-buttonset.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-splitbutton.p-button-success > .p-button.p-button-text:enabled:active,\n.p-splitbutton.p-button-success > .p-button.p-button-text:not(button):not(a):not(.p-disabled):active,\n.p-fileupload-choose.p-button-success.p-button-text:enabled:active,\n.p-fileupload-choose.p-button-success.p-button-text:not(button):not(a):not(.p-disabled):active {\n  background-color: transparent;\n  color: var(--green-dark);\n  border-color: transparent;\n}\n\n/* p-selectbutton */\n.p-selectbutton {\n  display: flex;\n  padding: 2px;\n  border-radius: 6px;\n  background-color: var(--gray-10);\n}\n.p-selectbutton .p-button {\n  flex: 1 1 0%;\n  min-width: max-content;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  border: none;\n  border-radius: 5px;\n  height: 28px;\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--gray-60);\n  background: transparent;\n  box-shadow: none;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n.p-selectbutton .p-button:hover,\n.p-selectbutton .p-button:focus {\n  color: var(--gray-100);\n  background: transparent !important;\n}\n.p-selectbutton .p-button.p-highlight {\n  color: var(--gray-100);\n  background: var(--primary-white) !important;\n  box-shadow: var(--shadow-level-1);\n}\n.p-selectbutton .p-button .p-button-label {\n  font-weight: 400;\n}\n\n.p-selectbutton.selectbutton-lg {\n  padding: 1px;\n  border-radius: 8px;\n}\n.p-selectbutton.selectbutton-lg .p-button {\n  border-radius: 7px;\n  height: 30px;\n}\n.p-selectbutton.selectbutton-lg .p-button .p-button-label {\n  font-weight: 500;\n  padding: 0 18px;\n}\n\n/* select button\n.p-selectbutton .p-button {\n  background: var(--primary-white);\n  border: 1px solid var(--gray-20);\n  color: var(--gray-80);\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n.p-selectbutton .p-button .p-button-icon-left,\n.p-selectbutton .p-button .p-button-icon-right {\n  color: var(--gray-80);\n}\n.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {\n  background: var(prima--primary-whiteeavy-blue-1);\n  border-color: var(--gray-20);\n  color: var(--gray-100);\n}\n.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-left,\n.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover .p-button-icon-right {\n  color: var(--gray-80);\n}\n.p-selectbutton .p-button.p-highlight {\n  background: var(--blue-100);\n  border-color: var(--blue-100);\n  color: var(--primary-white);\n}\n.p-selectbutton .p-button.p-highlight .p-button-icon-left,\n.p-selectbutton .p-button.p-highlight .p-button-icon-right {\n  color: var(--primary-white);\n}\n.p-selectbutton .p-button.p-highlight:hover {\n  background: var(--blue-dark);\n  border-color: var(--blue-dark);\n  color: var(--primary-white);\n}\n.p-selectbutton .p-button.p-highlight:hover .p-button-icon-left,\n.p-selectbutton .p-button.p-highlight:hover .p-button-icon-right {\n  color: var(--primary-white);\n}\n.p-selectbutton.p-invalid > .p-button {\n  border-color: var(--red-100);\n}\n.p-selectbutton .p-button {\n  margin: 0;\n}\n.p-selectbutton .p-button:not(:last-child) {\n  border-right: 0 none;\n}\n.p-selectbutton .p-button:not(:first-of-type):not(:last-of-type) {\n  border-radius: 0;\n}\n.p-selectbutton .p-button:first-of-type {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.p-selectbutton .p-button:last-of-type {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.p-selectbutton .p-button:focus {\n  position: relative;\n  z-index: 1;\n} */\n\n/* calendar */\n.p-calendar {\n  position: relative;\n  display: inline-flex;\n  max-width: 100%;\n}\n.p-calendar .p-inputtext {\n  flex: 1 1 auto;\n  width: 1%;\n}\n.p-calendar-w-btn-right .p-inputtext {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: none;\n}\n.p-calendar-w-btn-right .p-datepicker-trigger {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.p-calendar-w-btn-left .p-inputtext {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: none;\n}\n.p-calendar-w-btn-left .p-datepicker-trigger {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.p-calendar.p-invalid.p-component > .p-inputtext {\n  border-color: var(--red-100);\n}\n\n/* inputtext */\n.p-inputtext {\n  font-family: var(--font-family);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.005rem;\n  color: var(--gray-100);\n  background: var(--primary-white);\n  padding: 11px;\n  border: 1px solid var(--gray-20);\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n  appearance: none;\n  border-radius: 8px;\n}\n.p-inputtext::placeholder {\n  color: var(--gray-50);\n}\n.p-inputtext.inputtext-sm,\n.p-dropdown.dropdown-sm .p-inputtext,\n.p-calendar.calendar-sm .p-inputtext {\n  padding: 7px 9px;\n  border-radius: 6px;\n  font-size: 13px;\n}\n.p-inputtext.inputtext-xs,\n.p-dropdown.dropdown-xs .p-inputtext,\n.p-calendar.calendar-xs .p-inputtext {\n  padding: 7px 6px;\n  border-radius: 6px;\n  font-size: 11px;\n}\n.p-autocomplete.autocomplete-sm .p-inputtext {\n  padding: 7px 9px;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n  font-size: 13px;\n}\n.p-inputtext:enabled:hover {\n  color: var(--gray-60);\n  border-color: var(--gray-40);\n}\n.p-inputtext:enabled:focus {\n  color: var(--gray-100);\n  border-color: var(--blue-100);\n  box-shadow: none;\n  outline: 0 none;\n  outline-offset: 0;\n}\n\n/* dropdown */\n.p-dropdown {\n  color: var(--gray-100);\n  border: 1px solid var(--gray-20);\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n  border-radius: 8px;\n}\n.p-dropdown.dropdown-sm {\n  border-radius: 6px;\n}\n.p-dropdown.dropdown-xl {\n  border-radius: 10px;\n}\n\n.p-dropdown .p-dropdown-label.p-inputtext {\n  padding-right: 0;\n  border: none;\n}\n.p-dropdown:not(.p-disabled):hover,\n.p-dropdown:not(.p-disabled):hover .p-dropdown-label {\n  color: var(--gray-60);\n  border-color: var(--gray-40);\n}\n.p-dropdown:not(.p-disabled).p-focus,\n.p-dropdown:not(.p-disabled):focus .p-dropdown-label {\n  color: var(--gray-100);\n  border-color: var(--blue-100);\n  box-shadow: none;\n  /* box-shadow: var(--shadow-focus); */\n}\n.p-autocomplete-dropdown,\n.p-dropdown .p-dropdown-trigger {\n  color: var(--gray-40);\n  width: 34px;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.p-dropdown .p-dropdown-clear-icon {\n  color: var(--gray-40);\n  right: 34px;\n}\n.p-invalid.p-component,\n.p-inputnumber.p-invalid.p-component > .p-inputtext,\n.p-autocomplete.p-invalid.p-component > .p-inputtext {\n  border-color: var(--red-100) !important;\n}\n.p-dropdown.no-trigger .p-dropdown-trigger {\n  display: none;\n}\n\n/* dropdown panel*/\n.p-dropdown-panel {\n  background-color: var(--primary-white);\n  color: var(--gray-80);\n  border: 0 none;\n  border-radius: 8px;\n  box-shadow: var(--shadow-level-2);\n}\n.p-dropdown-panel .p-dropdown-header {\n  padding: 8px 0 4px;\n  margin: 0 4px;\n  background: none;\n  border-bottom: 1px solid var(--gray-10);\n}\n.p-dropdown-panel .p-dropdown-header .p-dropdown-filter {\n  padding-left: 40px;\n  padding-right: 0;\n  border: 0 none;\n}\n.p-dropdown-panel .p-dropdown-header .p-dropdown-filter-icon,\n.p-dropdown-panel .p-dropdown-header .p-dropdown-filter-clear-icon {\n  position: absolute;\n  margin: 0;\n  top: 12px;\n  left: 12px;\n  color: var(--gray-60);\n}\n.p-dropdown-panel .p-dropdown-header .p-dropdown-clearable-filter .p-dropdown-filter {\n  padding-right: 48px;\n}\n.p-dropdown-panel .p-dropdown-header .p-dropdown-clearable-filter .p-dropdown-filter-clear-icon {\n  right: 32px;\n  cursor: pointer;\n}\n.p-dropdown-panel .p-dropdown-items {\n  padding: 4px;\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item {\n  background: transparent;\n  color: var(--gray-80);\n  margin: 0;\n  padding: 0 12px;\n  border: 0 none;\n  border-radius: 8px;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 13px;\n  letter-spacing: 0.005rem;\n  height: 40px;\n  display: flex;\n  align-items: center;\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {\n  background-color: var(--blue-4);\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-disabled):hover {\n  background-color: var(--gray-1) !important;\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-disabled):focus {\n  outline: none !important;\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item-group {\n  margin: 0;\n  padding: 6px 12px 2px;\n  border: 0 none;\n  background: transparent;\n  color: var(--gray-60);\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 10px;\n  letter-spacing: -0.01rem;\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-empty-message {\n  padding: 12px;\n  color: var(--gray-80);\n  background: transparent;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 13px;\n  letter-spacing: 0.005rem;\n}\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item .p-dropdown-item-label {\n  width: 100%;\n}\n\n/* calendar */\n.p-calendar {\n  position: relative;\n  display: inline-flex;\n  max-width: 100%;\n}\n.p-calendar .p-inputtext {\n  flex: 1 1 auto;\n  width: 1%;\n}\n.p-calendar .p-datepicker-trigger {\n  width: 40px;\n  padding: 0;\n}\n.p-calendar-w-btn-right .p-inputtext {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border-right: none;\n}\n.p-calendar-w-btn-right .p-datepicker-trigger {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.p-calendar-w-btn-left .p-inputtext {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n  border-left: none;\n}\n.p-calendar-w-btn-left .p-datepicker-trigger {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.p-calendar.calendar-sm .p-datepicker-trigger {\n  width: 32px;\n}\n\n/* checkbox */\n.p-checkbox {\n  width: 20px;\n  height: 20px;\n}\n.p-checkbox .p-checkbox-box {\n  border: 1px solid var(--gray-20);\n  background: var(--primary-white);\n  width: 20px;\n  height: 20px;\n  color: var(--gray-40);\n  border-radius: 4px;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n.p-checkbox .p-checkbox-box .p-checkbox-icon {\n  transition-duration: 0.2s;\n  color: var(--primary-white);\n  font-size: 14px;\n}\n.p-checkbox.p-highlight .p-checkbox-box {\n  border-color: var(--blue-100);\n  background: var(--blue-100);\n}\n.p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {\n  border-color: var(--blue-dark);\n  background: var(--blue-dark);\n  color: var(--primary-white);\n}\n.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {\n  border-color: var(--gray-40);\n}\n.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: var(--shadow-focus);\n  border-color: var(--blue-100);\n}\n.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {\n  border-color: var(--blue-dark);\n  background: var(--blue-dark);\n  color: var(--primary-white);\n}\n.p-checkbox .p-checkbox-box.p-disabled:not(.p-highlight) {\n  border-color: var(--gray-10);\n  background: var(--gray-10);\n  opacity: 1;\n}\n.p-checkbox.p-invalid > .p-checkbox-box {\n  border-color: var(--red-100);\n}\n\n/* datepicker */\n.p-datepicker:not(.p-datepicker-inline) {\n  background: var(--primary-white);\n  border: 0 none;\n  border-radius: 8px;\n  box-shadow: 0px 4px 22px 0px rgba(14, 36, 59, 0.1);\n  transform: translate(10px, -4px);\n}\n\n/* avatar */\n.p-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 12px;\n  letter-spacing: 0.01rem;\n  background-color: var(--blue-20);\n  color: var(--blue-dark);\n  overflow: hidden;\n}\n.p-avatar.p-avatar-lg {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  font-size: 12px;\n  line-height: 16px;\n}\n.p-avatar.p-avatar-xl {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 16px;\n}\n/* menu */\n.p-menu {\n  padding: 6px 0;\n  background: var(--primary-white);\n  color: var(--gray-80);\n  border: 0 none;\n  border-radius: 8px;\n  --menu-width: max-content;\n  width: var(--menu-width);\n  max-width: 240px;\n  min-width: 115px;\n}\n.p-menu.p-menu-overlay {\n  border: 0 none;\n  box-shadow: var(--shadow-level-2);\n  margin: 4px 0;\n}\n.p-menu .p-menu-separator {\n  border-top: 1px solid var(--gray-20);\n  margin: 6px 0;\n}\n.p-menu .p-menu-item {\n  color: var(--gray-80);\n  font-size: 13px;\n  line-height: 13px;\n  font-weight: 400;\n}\n.p-menu .p-menuitem-link {\n  min-height: 40px;\n  padding: 12px;\n  border: 2px solid var(--primary-white);\n  border-left-width: 4px;\n  border-right-width: 4px;\n  border-radius: 8px;\n}\n.p-menu .p-menuitem-link:not(.p-disabled):hover {\n  background-color: var(--gray-1);\n}\n.p-menu .p-menuitem-text {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 13px;\n  letter-spacing: 0.005rem;\n}\n\n/* inputgroup */\n.p-inputgroup-addon {\n  background: var(--primary-white);\n  color: var(--gray-60);\n  border-top: none;\n  border-left: none;\n  border-bottom: none;\n  padding: 0;\n  min-width: 40px;\n}\n.p-inputgroup-addon:last-child {\n  border-right: none;\n}\n.p-inputgroup.inputgroup-sm .p-inputgroup-addon {\n  min-width: 32px;\n}\n.p-inputgroup.inputgroup-xl .p-inputgroup-addon {\n  min-width: 48px;\n}\n\n.p-inputgroup > .p-component,\n.p-inputgroup > .p-inputwrapper > .p-inputtext,\n.p-inputgroup > .p-float-label > .p-component {\n  border-radius: 0;\n  margin: 0;\n}\n.p-inputgroup > .p-component + .p-inputgroup-addon,\n.p-inputgroup > .p-inputwrapper > .p-inputtext + .p-inputgroup-addon,\n.p-inputgroup > .p-float-label > .p-component + .p-inputgroup-addon {\n  border-left: 0 none;\n}\n.p-inputgroup > .p-component:focus,\n.p-inputgroup > .p-inputwrapper > .p-inputtext:focus,\n.p-inputgroup > .p-float-label > .p-component:focus {\n  z-index: 1;\n}\n.p-inputgroup > .p-component:focus ~ label,\n.p-inputgroup > .p-inputwrapper > .p-inputtext:focus ~ label,\n.p-inputgroup > .p-float-label > .p-component:focus ~ label {\n  z-index: 1;\n}\n\n.p-inputgroup-addon:first-child,\n.p-inputgroup button:first-child,\n.p-inputgroup input:first-child,\n.p-inputgroup > .p-inputwrapper:first-child,\n.p-inputgroup > .p-inputwrapper:first-child > .p-inputtext {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n.p-inputgroup .p-float-label:first-child input {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n.p-inputgroup-addon:last-child,\n.p-inputgroup button:last-child,\n.p-inputgroup input:last-child,\n.p-inputgroup > .p-inputwrapper:last-child,\n.p-inputgroup > .p-inputwrapper:last-child > .p-inputtext {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.p-inputgroup .p-float-label:last-child input {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.p-inputgroup.inputgroup-sm .p-inputgroup-addon:first-child,\n.p-inputgroup.inputgroup-sm button:first-child,\n.p-inputgroup.inputgroup-sm input:first-child,\n.p-inputgroup.inputgroup-sm > .p-inputwrapper:first-child,\n.p-inputgroup.inputgroup-sm > .p-inputwrapper:first-child > .p-inputtext {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.p-inputgroup.inputgroup-sm .p-float-label:first-child input {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.p-inputgroup.inputgroup-sm .p-inputgroup-addon:last-child,\n.p-inputgroup.inputgroup-sm button:last-child,\n.p-inputgroup.inputgroup-sm input:last-child,\n.p-inputgroup.inputgroup-sm > .p-inputwrapper:last-child,\n.p-inputgroup.inputgroup-sm > .p-inputwrapper:last-child > .p-inputtext {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.p-inputgroup.inputgroup-sm .p-float-label:last-child input {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.p-inputgroup.inputgroup-xl .p-inputgroup-addon:first-child,\n.p-inputgroup.inputgroup-xl button:first-child,\n.p-inputgroup.inputgroup-xl input:first-child,\n.p-inputgroup.inputgroup-xl > .p-inputwrapper:first-child,\n.p-inputgroup.inputgroup-xl > .p-inputwrapper:first-child > .p-inputtext {\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n.p-inputgroup.inputgroup-xl .p-float-label:first-child input {\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n.p-inputgroup.inputgroup-xl .p-inputgroup-addon:last-child,\n.p-inputgroup.inputgroup-xl button:last-child,\n.p-inputgroup.inputgroup-xl input:last-child,\n.p-inputgroup.inputgroup-xl > .p-inputwrapper:last-child,\n.p-inputgroup.inputgroup-xl > .p-inputwrapper:last-child > .p-inputtext {\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n.p-inputgroup.inputgroup-xl .p-float-label:last-child input {\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.p-fluid .p-inputgroup .p-button {\n  width: auto;\n}\n\n.p-tabview .p-tabview-nav {\n  background: var(--primary-white);\n  border: 1px solid var(--gray-20);\n  border-width: 0 0 1px 0;\n}\n.p-tabview .p-tabview-nav li {\n  margin-right: 0;\n}\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  background: transparent;\n  color: var(--gray-60);\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.01rem;\n  font-weight: 500;\n  border: solid transparent;\n  border-width: 0 0 2px 0;\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n  transition: none;\n  padding: 8px 16px;\n  margin: 0 0 -1px 0;\n  height: 40px;\n}\n.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: none;\n}\n.p-tabview .p-tabview-nav li:not(.p-disabled):hover .p-tabview-nav-link {\n  background: var(--gray-1);\n}\n.p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link {\n  background: var(--gray-1);\n  border-color: transparent;\n}\n.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  background: transparent;\n  border-color: var(--blue-100);\n  color: var(--blue-100);\n}\n.p-tabview .p-tabview-panels {\n  background: transparent;\n  padding: 0;\n  border: 0 none;\n  color: initial;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.p-tabview.tabview-embed {\n  display: flex;\n  flex-direction: column;\n}\n.p-tabview.tabview-embed .p-tabview-panels {\n  flex-grow: 1;\n  height: 0;\n}\n\n/* multiselect */\n.p-multiselect {\n  color: var(--gray-100);\n  border: 1px solid var(--gray-20);\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n  border-radius: 8px;\n}\n.p-multiselect:not(.p-disabled):hover {\n  color: var(--gray-60);\n  border-color: var(--gray-40);\n}\n.p-multiselect:not(.p-disabled).p-focus {\n  color: var(--gray-100);\n  border-color: var(--blue-100);\n  box-shadow: none;\n  outline: 0 none;\n  outline-offset: 0;\n}\n.p-multiselect.p-multiselect-clearable .p-multiselect-label {\n  padding-right: 24px;\n}\n.p-multiselect .p-multiselect-label {\n  padding: 12px;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n.p-multiselect .p-multiselect-label.p-placeholder {\n  color: var(--gray-50);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 14px;\n  letter-spacing: 0.005rem;\n  padding: 12px;\n}\n.p-multiselect.p-multiselect-chip {\n  border-radius: 8px;\n  border-color: var(--gray-40);\n}\n.p-multiselect.p-multiselect-chip .p-multiselect-token {\n  height: 40px;\n  padding: 8px;\n  margin-right: 4px;\n  background: var(--gray-1);\n  color: var(--gray-100);\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 14px;\n  letter-spacing: 0.005rem;\n  font-weight: 500;\n}\n.p-multiselect.p-multiselect-chip .p-multiselect-token .p-multiselect-token-icon {\n  margin-left: 8px;\n  color: var(--gray-50);\n  font-size: 12px;\n}\n.p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label {\n  padding: 12px;\n}\n.p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label.p-multiselect-items-label {\n  padding: 12px;\n}\n.p-multiselect .p-multiselect-trigger {\n  align-items: flex-start;\n  padding: 12px 10px 0 0;\n  color: var(--gray-40);\n  background: transparent;\n  width: 24px;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.p-multiselect .p-multiselect-clear-icon {\n  color: var(--gray-60);\n  right: 24px;\n}\n.p-multiselect.p-invalid.p-component {\n  border-color: var(--red-100);\n}\n.p-multiselect-panel {\n  background: var(--primary-white);\n  color: var(--gray-60);\n  border: 0 none;\n  border-radius: 8px;\n  box-shadow: var(--shadow-level-2);\n}\n.p-multiselect-panel .custom-multiselect-header {\n  padding: 4px 4px 0;\n}\n.p-multiselect-panel .custom-multiselect-header .p-multiselect-filter-container .p-inputtext {\n  padding: 12px 12px 12px 44px;\n  border-width: 0;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0;\n}\n.p-multiselect-panel .custom-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {\n  left: 12px;\n  margin: 0;\n  transform: translateY(-50%);\n  color: var(--gray-60);\n}\n.p-multiselect-panel .p-multiselect-header {\n  padding: 10px 16px;\n  border-bottom: 0 none;\n  color: var(--gray-60);\n  background: var(--primary-white);\n  margin: 0;\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n}\n.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container {\n  margin: 0 10px;\n}\n.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-inputtext {\n  padding-right: 24px;\n}\n.p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {\n  right: 10px;\n  color: var(--gray-60);\n}\n.p-multiselect-panel .p-multiselect-header .p-multiselect-close {\n  width: 20px;\n  height: 20px;\n  color: var(--gray-60);\n  border: 0 none;\n  background: transparent;\n  border-radius: 4px;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    box-shadow 0.2s;\n}\n.p-multiselect-panel .p-multiselect-header .p-multiselect-close:enabled:hover {\n  color: var(--gray-100);\n  border-color: transparent;\n  background: var(--gray-1);\n}\n.p-multiselect-panel .p-multiselect-header .p-multiselect-close:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: none;\n}\n.p-multiselect-panel .p-multiselect-items {\n  padding: 4px;\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item {\n  margin: 0;\n  padding: 10px 12px;\n  border: 0 none;\n  color: var(--gray-80);\n  background: transparent;\n  transition: box-shadow 0.2s;\n  border-radius: 4px;\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item > span {\n  width: 100%;\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {\n  color: var(--gray-100);\n  background: var(--primary-white);\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item:not(.p-highlight):not(.p-disabled):hover {\n  color: var(--gray-100);\n  background: var(--gray-1);\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: none;\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item .p-checkbox {\n  margin-right: 12px;\n  pointer-events: none;\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item-group {\n  margin: 0;\n  padding: 10px 12px;\n  color: var(--gray-60);\n  background: var(--primary-white);\n  font-weight: 400;\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-empty-message {\n  padding: 10px 12px;\n  color: var(--gray-50);\n  background: transparent;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0.005rem;\n}\n\n/* multiselect compact chips */\n.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-label {\n  padding: 4px 6px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-label.p-placeholder,\n.p-inputwrapper-filled.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-label {\n  padding: 8px 10px;\n}\n.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-token {\n  height: 24px;\n  padding: 2px 6px;\n  margin-right: 0;\n  font-size: 12px;\n  line-height: 12px;\n  border-radius: 4px;\n  max-width: 100%;\n  min-width: 0;\n}\n.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-token .p-multiselect-token-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0.005rem;\n  font-weight: 400;\n}\n.p-multiselect.multiselect-compact.p-multiselect-chip .p-multiselect-token .p-multiselect-token-icon {\n  margin-left: 8px;\n  color: var(--gray-100);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.p-multiselect.multiselect-compact .p-multiselect-trigger {\n  align-items: center;\n  padding: 0 10px 0 0;\n}\n\n/* input compact */\n.p-inputtext.input-compact {\n  height: 32px;\n  padding: 0 10px;\n}\n\n/* multiselect compact panel (no checkboxes, custom header) */\n.multiselect-compact-panel .custom-multiselect-header {\n  padding: 4px 4px 0;\n  border-bottom: 1px solid var(--gray-10);\n}\n.multiselect-compact-panel .custom-multiselect-header .p-multiselect-filter-container .p-inputtext {\n  padding: 12px 12px 12px 40px;\n  border-width: 0;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0;\n}\n.multiselect-compact-panel .custom-multiselect-header .p-multiselect-filter-container .p-multiselect-filter-icon {\n  left: 12px;\n  margin: 0;\n  transform: translateY(-50%);\n  color: var(--gray-60);\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n}\n.multiselect-compact-panel .p-multiselect-items .p-multiselect-item {\n  padding: 0 12px;\n  min-height: 40px;\n  max-height: 40px;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0.005rem;\n}\n.multiselect-compact-panel .p-multiselect-items .p-multiselect-item:hover {\n  background: var(--blue-4);\n}\n.multiselect-compact-panel .p-multiselect-items .p-multiselect-item > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* inputswitch */\n.p-inputswitch {\n  width: 40px;\n  height: 24px;\n}\n.p-inputswitch:is(.size-small) {\n  width: 36px;\n  height: 20px;\n}\n.p-inputswitch .p-inputswitch-slider {\n  background: var(--gray-10);\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n  border-radius: 30px;\n}\n.p-inputswitch .p-inputswitch-slider:before {\n  background: var(--primary-white);\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  transition-duration: 0.2s;\n  margin: -10px 2px 2px 2px;\n  left: 0;\n  box-shadow: 0px 0px 2px 0px #0000001a;\n}\n.p-inputswitch:is(.size-small) .p-inputswitch-slider:before {\n  width: 16px;\n  height: 16px;\n  margin: -8px 2px 2px 2px;\n}\n.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before,\n.p-inputswitch.p-highlight .p-inputswitch-slider:before,\n.p-inputswitch:is(.size-small).p-inputswitch-checked .p-inputswitch-slider:before,\n.p-inputswitch:is(.size-small).p-highlight .p-inputswitch-slider:before {\n  transform: translateX(15px);\n}\n.p-inputswitch.p-focus .p-inputswitch-slider {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0px 0px 0px 4px #deebf9;\n}\n.p-inputswitch:not(.p-disabled):hover .p-inputswitch-slider {\n  background: #dce2ec;\n}\n.p-inputswitch:is(.p-disabled) .p-inputswitch-slider {\n  background: #dce1ec;\n}\n.p-inputswitch:is(.p-disabled) .p-inputswitch-slider:before {\n  background: #f6f7fa;\n}\n.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider,\n.p-inputswitch.p-highlight .p-inputswitch-slider {\n  background: var(--blue-100);\n}\n.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before,\n.p-inputswitch.p-highlight .p-inputswitch-slider:before {\n  background: var(--primary-white);\n}\n.p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider,\n.p-inputswitch.p-highlight:not(.p-disabled):hover .p-inputswitch-slider {\n  background: var(--blue-dark);\n}\n.p-inputswitch.p-inputswitch-checked:is(.p-disabled) .p-inputswitch-slider,\n.p-inputswitch.p-highlight:is(.p-disabled) .p-inputswitch-slider {\n  opacity: 50%;\n}\n.p-inputswitch.p-inputswitch-checked:is(.p-disabled) .p-inputswitch-slider:before,\n.p-inputswitch.p-highlight:is(.p-disabled) .p-inputswitch-slider:before {\n  background: var(--blue-20);\n}\n\n/* dialog */\n.p-dialog {\n  border-radius: 8px;\n  box-shadow: 0px 4px 16px 0px #0e243b0f;\n  border: 0 none;\n}\n.p-dialog .p-dialog-header {\n  border-radius: 8px 8px 0px 0px;\n  border-bottom: 1px solid var(--gray-20);\n  background: var(--primary-white);\n  color: var(--gray-100);\n  padding: 20px;\n}\n.p-dialog .p-dialog-header .p-dialog-title {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 22px;\n}\n.p-dialog .p-dialog-header .p-dialog-header-icon {\n  width: 20px;\n  height: 20px;\n  color: var(--gray-60);\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    box-shadow 0.2s;\n}\n.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {\n  color: var(--gray-100);\n  border-color: transparent;\n  background: var(--primary-white);\n}\n.p-dialog .p-dialog-header .p-dialog-header-icon:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem var(--gray-10);\n}\n.p-dialog .p-dialog-header .p-dialog-header-icon:last-child {\n  margin-right: 0;\n}\n.p-dialog .p-dialog-content {\n  background: var(--primary-white);\n  color: var(--gray-100);\n  padding: 20px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 19px;\n}\n.p-dialog .p-dialog-content:last-of-type {\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n.p-dialog .p-dialog-footer {\n  border-top: 1px solid var(--gray-20);\n  background: var(--primary-white);\n  color: var(--gray-80);\n  padding: 12px 20px;\n  text-align: left;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n  display: flex;\n}\n.p-dialog .p-dialog-footer button {\n  padding: 10px 18px;\n  margin: 0;\n  width: auto;\n  border-radius: 10px;\n  min-width: 120px;\n  min-height: 48px;\n  justify-content: center;\n}\n\n/* datepicker */\n.p-datepicker {\n  padding: 4px;\n  background: var(--primary-white);\n  color: #4b5563;\n  border: 0 none;\n  border-radius: 8px;\n}\n.p-datepicker:not(.p-datepicker-inline) {\n  background: var(--primary-white);\n  border: 0 none;\n  box-shadow: 0px 4px 22px 0px #0e243b1a;\n}\n.p-datepicker:not(.p-datepicker-inline) .p-datepicker-header {\n  background: var(--primary-white);\n}\n.p-datepicker .p-datepicker-header {\n  padding: 4px;\n  color: #4b5563;\n  background: var(--primary-white);\n  font-weight: 600;\n  margin: 0;\n  border-bottom: 0 none;\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n}\n.p-datepicker .p-datepicker-header .p-datepicker-prev,\n.p-datepicker .p-datepicker-header .p-datepicker-next {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    box-shadow 0.2s;\n}\n.p-datepicker .p-datepicker-header .p-datepicker-prev:enabled:hover,\n.p-datepicker .p-datepicker-header .p-datepicker-next:enabled:hover {\n  color: #4b5563;\n  border-color: transparent;\n  background: #e9ecef;\n}\n.p-datepicker .p-datepicker-header .p-datepicker-prev:focus,\n.p-datepicker .p-datepicker-header .p-datepicker-next:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #a6d5fa;\n}\n.p-datepicker .p-datepicker-header .p-datepicker-title {\n  line-height: 2rem;\n}\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {\n  color: #4b5563;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    box-shadow 0.2s;\n  font-weight: 600;\n  padding: 0.5rem;\n}\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:enabled:hover,\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:enabled:hover {\n  color: #2196f3;\n}\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {\n  margin-right: 0.5rem;\n}\n.p-datepicker table {\n  font-size: 14px;\n  margin: 0.5rem 0;\n}\n.p-datepicker table th {\n  padding: 0;\n}\n.p-datepicker table th > span {\n  width: 42px;\n  height: 42px;\n}\n.p-datepicker table td {\n  padding: 4px;\n}\n.p-datepicker table td > span {\n  width: 42px;\n  height: 42px;\n  border-radius: 6px;\n  transition: box-shadow 0.2s;\n  border: 1px solid transparent;\n}\n.p-datepicker table td > span.p-highlight {\n  color: #4b5563;\n  border-color: var(--blue-100);\n  background: var(--primary-white);\n}\n.p-datepicker table td > span.p-highlight:hover {\n  background: var(--gray-1);\n}\n.p-datepicker table td > span:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: none;\n  color: var(--blue-100);\n  border-color: var(--blue-100);\n  background: var(--blue-4);\n}\n.p-datepicker table td.p-datepicker-today > span {\n  background: #d2d5db;\n  color: #4b5563;\n  border-color: #d2d5db;\n}\n.p-datepicker table td.p-datepicker-today > span.p-highlight {\n  background: #d2d5db;\n  border-color: #d2d5db;\n}\n.p-datepicker .p-datepicker-buttonbar {\n  padding: 1rem 0;\n  border-top: 1px solid #dee2e6;\n}\n.p-datepicker .p-datepicker-buttonbar .p-button {\n  width: auto;\n}\n.p-datepicker .p-timepicker {\n  border-top: 1px solid #dee2e6;\n  padding: 0.5rem;\n}\n.p-datepicker .p-timepicker button {\n  width: 2rem;\n  height: 2rem;\n  color: #6c757d;\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    box-shadow 0.2s;\n}\n.p-datepicker .p-timepicker button:enabled:hover {\n  color: #4b5563;\n  border-color: transparent;\n  background: #e9ecef;\n}\n.p-datepicker .p-timepicker button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #a6d5fa;\n}\n.p-datepicker .p-timepicker button:last-child {\n  margin-top: 0.2em;\n}\n.p-datepicker .p-timepicker span {\n  font-size: 1.25rem;\n}\n.p-datepicker .p-timepicker > div {\n  padding: 0 0.5rem;\n}\n.p-datepicker.p-datepicker-timeonly .p-timepicker {\n  border-top: 0 none;\n}\n.p-datepicker .p-monthpicker {\n  margin: 0.5rem 0;\n}\n.p-datepicker .p-monthpicker .p-monthpicker-month {\n  padding: 0.5rem;\n  transition: box-shadow 0.2s;\n  border-radius: 4px;\n}\n.p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {\n  color: #4b5563;\n  background: #e3f2fd;\n}\n.p-datepicker .p-yearpicker {\n  margin: 0.5rem 0;\n}\n.p-datepicker .p-yearpicker .p-yearpicker-year {\n  padding: 0.5rem;\n  transition: box-shadow 0.2s;\n  border-radius: 4px;\n}\n.p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight {\n  color: #4b5563;\n  background: #e3f2fd;\n}\n.p-datepicker.p-datepicker-multiple-month .p-datepicker-group {\n  border-left: 1px solid #dee2e6;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:first-child {\n  padding-left: 0;\n}\n.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {\n  padding-right: 0;\n  border-left: 0 none;\n}\n.p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):hover {\n  background: var(--gray-1);\n  border-color: var(--gray-1);\n}\n.p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: none;\n  color: var(--blue-100);\n  border-color: var(--blue-100);\n  background: var(--blue-4);\n}\n.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):not(.p-highlight):hover {\n  background: #e9ecef;\n}\n.p-datepicker:not(.p-disabled) .p-monthpicker .p-monthpicker-month:not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #a6d5fa;\n}\n.p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):not(.p-highlight):hover {\n  background: #e9ecef;\n}\n.p-datepicker:not(.p-disabled) .p-yearpicker .p-yearpicker-year:not(.p-disabled):focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #a6d5fa;\n}\n\n/* scrollpanel */\n.p-scrollpanel {\n  width: 100%;\n  height: 100%;\n}\n.p-scrollpanel .p-scrollpanel-bar {\n  background: var(--gray-20);\n}\n.p-scrollpanel .p-scrollpanel-content {\n  padding: 0;\n}\n.p-scrollpanel .p-scrollpanel-content > div {\n  max-width: 100vw;\n}\n\n/* datatable */\n/* .p-datatable .p-paginator-top {\n  border-width: 0 0 1px 0;\n  border-radius: 14px 14px 0 0;\n}\n.p-datatable .p-paginator-bottom {\n  border-width: 0 0 1px 0;\n  border-radius: 0 0 14px 14px;\n} */\n.p-datatable .p-datatable-header {\n  background: var(--primary-white);\n  color: var(--gray-60);\n  border: 1px solid var(--gray-10);\n  border-width: 0 0 1px 0;\n  padding: 8px 16px;\n  font-weight: 400;\n}\n.p-datatable .p-datatable-footer {\n  background: var(--primary-white);\n  color: var(--gray-60);\n  border: none;\n  border-width: 0;\n  padding: 8px 16px;\n  font-weight: 400;\n}\n.p-datatable .p-datatable-thead > tr > th {\n  text-align: left;\n  padding: 8px;\n  border: 1px solid var(--gray-10);\n  border-width: 0 0 1px 0;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0.01rem;\n  color: var(--gray-60);\n  background: var(--primary-white);\n}\n.p-datatable .p-datatable-thead > tr > th:first-child {\n  padding-left: 16px;\n}\n.p-datatable .p-datatable-thead > tr > th:last-child {\n  padding-right: 16px;\n}\n.p-datatable .p-datatable-tfoot > tr > td {\n  text-align: left;\n  padding: 8px;\n  border: 1px solid var(--gray-10);\n  border-width: 0;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0.01rem;\n  color: var(--gray-60);\n  background: var(--primary-white);\n}\n.p-datatable .p-datatable-tfoot > tr > td:first-child {\n  padding-left: 16px;\n}\n.p-datatable .p-datatable-tfoot > tr > td:last-child {\n  padding-right: 16px;\n}\n.p-datatable .p-sortable-column .p-sortable-column-icon {\n  color: var(--gray-100);\n  margin-left: 4px;\n}\n.p-datatable .p-sortable-column .p-sortable-column-badge {\n  border-radius: 50%;\n  height: 16px;\n  min-width: 16px;\n  line-height: 16px;\n  color: var(--gray-80);\n  background: var(--gray-1);\n  margin-left: 4px;\n}\n.p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover {\n  background: var(--gray-1);\n  color: var(--gray-100);\n}\n.p-datatable .p-sortable-column:not(.p-highlight):not(.p-sortable-disabled):hover .p-sortable-column-icon {\n  color: var(--gray-100);\n}\n.p-datatable .p-sortable-column.p-highlight {\n  background: var(--primary-white);\n  color: var(--gray-100);\n}\n.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {\n  color: var(--gray-100);\n}\n.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover {\n  background: var(--gray-1);\n  color: var(--gray-100);\n}\n.p-datatable .p-sortable-column.p-highlight:not(.p-sortable-disabled):hover .p-sortable-column-icon {\n  color: var(--gray-100);\n}\n.p-datatable .p-sortable-column:focus {\n  box-shadow: none;\n  outline: 0 none;\n}\n.p-datatable .p-datatable-tbody > tr {\n  background: var(--primary-white);\n  color: var(--gray-100);\n  transition: box-shadow 0.2s;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 32px;\n}\n.p-datatable .p-datatable-tbody > tr > td {\n  text-align: left;\n  border: 1px solid var(--gray-1);\n  border-width: 0 0 1px 0;\n  padding: 5px 8px 6px;\n}\n.p-datatable .p-datatable-tbody > tr > td:first-child {\n  padding-left: 16px;\n}\n.p-datatable .p-datatable-tbody > tr > td:last-child {\n  padding-right: 16px;\n}\n.p-datatable .p-datatable-tbody > tr > td .p-row-toggler,\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init,\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save,\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel {\n  width: 32px;\n  height: 32px;\n  color: var(--gray-60);\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    box-shadow 0.2s;\n}\n.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:enabled:hover,\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init:enabled:hover,\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save:enabled:hover,\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel:enabled:hover {\n  color: var(--gray-100);\n  border-color: transparent;\n  background: var(--gray-1);\n}\n.p-datatable .p-datatable-tbody > tr > td .p-row-toggler:focus,\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-init:focus,\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save:focus,\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem var(--blue-4);\n}\n.p-datatable .p-datatable-tbody > tr > td .p-row-editor-save {\n  margin-right: 4px;\n}\n.p-datatable .p-datatable-tbody > tr > td > .p-column-title {\n  font-weight: 400;\n}\n.p-datatable .p-datatable-tbody > tr > td.p-highlight {\n  background: var(--gray-1);\n  color: var(--gray-100);\n}\n.p-datatable .p-datatable-tbody > tr.p-highlight {\n  background: var(--gray-1);\n  color: var(--gray-100);\n}\n.p-datatable .p-datatable-tbody > tr.p-datatable-dragpoint-top > td {\n  box-shadow: inset 0 2px 0 0 var(--blue-4);\n}\n.p-datatable .p-datatable-tbody > tr.p-datatable-dragpoint-bottom > td {\n  box-shadow: inset 0 -2px 0 0 var(--blue-4);\n}\n.p-datatable.p-datatable-selectable .p-datatable-tbody > tr.p-selectable-row:not(.p-highlight):not(.p-datatable-emptymessage):hover {\n  background: var(--gray-1);\n  color: var(--gray-100);\n}\n.p-datatable.p-datatable-selectable .p-datatable-tbody > tr.p-selectable-row:focus {\n  outline: 2px solid var(--blue-4);\n  outline-offset: -2px;\n}\n.p-datatable.p-datatable-selectable-cell .p-datatable-tbody > tr.p-selectable-row > td.p-selectable-cell:not(.p-highlight):hover {\n  background: var(--gray-1);\n  color: var(--gray-100);\n}\n.p-datatable.p-datatable-selectable-cell .p-datatable-tbody > tr.p-selectable-row > td.p-selectable-cell:focus {\n  outline: 2px solid var(--blue-4);\n  outline-offset: -2px;\n}\n.p-datatable.p-datatable-hoverable-rows .p-datatable-tbody > tr:not(.p-highlight):not(.p-datatable-emptymessage):hover {\n  background: var(--gray-1);\n  color: var(--gray-100);\n}\n.p-datatable .p-column-resizer-helper {\n  background: var(--blue-100);\n}\n.p-datatable .p-datatable-scrollable-header,\n.p-datatable .p-datatable-scrollable-footer {\n  background: var(--gray-1);\n}\n.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-datatable-table > .p-datatable-thead,\n.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-datatable-table > .p-datatable-tfoot,\n.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-virtualscroller > .p-datatable-table > .p-datatable-thead,\n.p-datatable.p-datatable-scrollable > .p-datatable-wrapper > .p-virtualscroller > .p-datatable-table > .p-datatable-tfoot {\n  background-color: var(--gray-1);\n}\n.p-datatable .p-datatable-loading-icon {\n  font-size: 20px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-header {\n  border-width: 1px 1px 0 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-footer {\n  border-width: 0 1px 1px 1px;\n}\n.p-datatable.p-datatable-gridlines .p-paginator-top {\n  border-width: 0 1px 0 1px;\n}\n.p-datatable.p-datatable-gridlines .p-paginator-bottom {\n  border-width: 0 1px 1px 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th {\n  border-width: 1px 0 1px 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th:last-child {\n  border-width: 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr > td {\n  border-width: 1px 0 0 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr > td:last-child {\n  border-width: 1px 1px 0 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr:last-child > td {\n  border-width: 1px 0 1px 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-tbody > tr:last-child > td:last-child {\n  border-width: 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-tfoot > tr > td {\n  border-width: 1px 0 1px 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-tfoot > tr > td:last-child {\n  border-width: 1px 1px 1px 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-thead + .p-datatable-tfoot > tr > td {\n  border-width: 0 0 1px 1px;\n}\n.p-datatable.p-datatable-gridlines .p-datatable-thead + .p-datatable-tfoot > tr > td:last-child {\n  border-width: 0 1px 1px 1px;\n}\n.p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody > tr > td {\n  border-width: 0 0 1px 1px;\n}\n.p-datatable.p-datatable-gridlines:has(.p-datatable-thead):has(.p-datatable-tbody) .p-datatable-tbody > tr > td:last-child {\n  border-width: 0 1px 1px 1px;\n}\n.p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody > tr:last-child > td {\n  border-width: 0 0 0 1px;\n}\n.p-datatable.p-datatable-gridlines:has(.p-datatable-tbody):has(.p-datatable-tfoot) .p-datatable-tbody > tr:last-child > td:last-child {\n  border-width: 0 1px 0 1px;\n}\n.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd {\n  background: var(--blue-4);\n}\n.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.p-highlight {\n  background: #e3f2fd;\n  color: var(--gray-100);\n}\n.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.p-highlight .p-row-toggler {\n  color: var(--gray-60);\n}\n.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.p-highlight .p-row-toggler:hover {\n  color: var(--gray-60);\n}\n.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd + .p-row-expanded {\n  background: var(--gray-1);\n}\n.p-datatable .p-datatable-tbody > tr > td {\n  text-align: left;\n  border: 1px solid var(--gray-1);\n  border-width: 0 0 1px 0;\n  padding: 6px 8px 5px;\n}\n.p-datatable .p-datatable-tbody > tr > td:first-child {\n  padding-left: 16px;\n}\n.p-datatable .p-datatable-tbody > tr > td:last-child {\n  padding-right: 16px;\n}\n.p-datatable.p-datatable-sm .p-datatable-header {\n  padding: 8px;\n}\n.p-datatable.p-datatable-sm .p-datatable-thead > tr > th {\n  padding: 8px;\n}\n.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {\n  padding: 1px 8px 2px;\n}\n.p-datatable.p-datatable-sm .p-datatable-tfoot > tr > td {\n  padding: 8px;\n}\n.p-datatable.p-datatable-sm .p-datatable-footer {\n  padding: 8px;\n}\n.p-datatable.p-datatable-lg .p-datatable-header {\n  padding: 12px;\n}\n.p-datatable.p-datatable-lg .p-datatable-thead > tr > th {\n  padding: 12px;\n}\n.p-datatable.p-datatable-lg .p-datatable-tbody > tr > td {\n  padding: 11px 8px 12px;\n}\n.p-datatable.p-datatable-lg .p-datatable-tfoot > tr > td {\n  padding: 12px;\n}\n.p-datatable.p-datatable-lg .p-datatable-footer {\n  padding: 12px;\n}\n.p-datatable-drag-selection-helper {\n  background: rgba(33, 150, 243, 0.16);\n}\n.p-selection-column .p-checkbox {\n  vertical-align: middle;\n}\n\n/* accordion */\n.p-accordion .p-accordion-header .p-accordion-header-link {\n  padding: 0;\n  border: none;\n  color: var(--gray-60);\n  background: transparent;\n  font-weight: 400;\n  border-radius: 8px;\n}\n.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {\n  display: none;\n}\n.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-header-text {\n  width: 100%;\n}\n.p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: none;\n}\n.p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {\n  background: var(--gray-1);\n  color: var(--gray-60);\n}\n.p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {\n  background: transparent;\n  color: var(--gray-60);\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n.p-accordion:not(.accordion-separate-header) .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.p-accordion .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {\n  background: var(--gray-1);\n  color: var(--gray-60);\n}\n.p-accordion .p-accordion-content {\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--gray-100);\n  border-top: 0;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.p-accordion .p-accordion-tab {\n  margin-bottom: 0;\n}\n.p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {\n  border-radius: 0;\n}\n.p-accordion .p-accordion-tab .p-accordion-content {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header .p-accordion-header-link {\n  border-top: 0 none;\n}\n.p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link,\n.p-accordion .p-accordion-tab:not(:first-child) .p-accordion-header:not(.p-disabled).p-highlight:hover .p-accordion-header-link {\n  border-top: 0 none;\n}\n.p-accordion .p-accordion-tab:first-child .p-accordion-header .p-accordion-header-link {\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n}\n.p-accordion .p-accordion-tab:last-child .p-accordion-header:not(.p-highlight) .p-accordion-header-link {\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n.p-accordion .p-accordion-tab:last-child .p-accordion-header:not(.p-highlight) .p-accordion-content {\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n/* sidebar */\n.p-sidebar {\n  background: var(--primary-white);\n  color: var(--gray-1);\n  border: 0 none;\n  box-shadow: var(--shadow-level-2);\n}\n.p-sidebar .p-sidebar-header {\n  padding: 1rem;\n}\n.p-sidebar .p-sidebar-header .p-sidebar-close,\n.p-sidebar .p-sidebar-header .p-sidebar-icon {\n  width: 2rem;\n  height: 2rem;\n  color: var(--gray-60);\n  border: 0 none;\n  background: transparent;\n  border-radius: 50%;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    box-shadow 0.2s;\n}\n.p-sidebar .p-sidebar-header .p-sidebar-close:enabled:hover,\n.p-sidebar .p-sidebar-header .p-sidebar-icon:enabled:hover {\n  color: var(--gray-80);\n  border-color: transparent;\n  background: var(--gray-10);\n}\n.p-sidebar .p-sidebar-header .p-sidebar-close:focus,\n.p-sidebar .p-sidebar-header .p-sidebar-icon:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: var(--shadow-focus);\n}\n.p-sidebar .p-sidebar-header + .p-sidebar-content {\n  padding-top: 0;\n}\n.p-sidebar .p-sidebar-content {\n  padding: 1rem;\n}\n\n/* tooltip */\n.p-tooltip .p-tooltip-text {\n  background: var(--primary-white);\n  color: var(--gray-100);\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0.005rem;\n  padding: 8px 12px;\n  box-shadow: var(--shadow-level-3);\n  border-radius: 4px;\n}\n.p-tooltip .p-tooltip-arrow {\n  display: none;\n}\n\n/* icon field */\n.p-icon-field {\n  position: relative;\n}\n.p-icon-field-left > .p-inputtext,\n.p-icon-field-left > .p-input-icon + .p-autocomplete .p-inputtext {\n  padding-left: 38px;\n}\n.p-icon-field-left.p-float-label > label {\n  left: 38px;\n}\n.p-icon-field-right > .p-inputtext,\n.p-icon-field-right > .p-autocomplete .p-inputtext {\n  padding-right: 38px;\n}\n.p-icon-field-left.icon-field-sm > .p-inputtext,\n.p-icon-field-left.icon-field-sm > .p-input-icon + .p-autocomplete .p-inputtext {\n  padding-left: 32px;\n}\n.p-icon-field-left.icon-field-sm.p-float-label > label {\n  left: 32px;\n}\n.p-icon-field-right.icon-field-sm > .p-inputtext,\n.p-icon-field-right.icon-field-sm > .p-autocomplete .p-inputtext {\n  padding-right: 32px;\n}\n.p-icon-field > .p-input-icon {\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  stroke-width: 2.25;\n  top: 50%;\n  margin-top: -8px;\n  color: var(--gray-50);\n  z-index: 10;\n}\n.p-fluid .p-icon-field-left,\n.p-fluid .p-icon-field-right {\n  width: 100%;\n}\n.p-icon-field-left > .p-input-icon:first-of-type {\n  left: 12px;\n}\n.p-icon-field-right > .p-input-icon:last-of-type {\n  right: 12px;\n}\n.p-icon-field-left.icon-field-sm > .p-input-icon:first-of-type {\n  left: 9px;\n}\n.p-icon-field-right.icon-field-sm > .p-input-icon:last-of-type {\n  right: 9px;\n}\n.p-icon-field-right.p-dropdown.icon-field-sm > .p-input-icon:last-of-type {\n  right: 32px;\n}\n.p-autocomplete.p-autocomplete-dd .p-autocomplete-loader {\n  right: 38px;\n}\n\n/* autocomplete */\n.p-autocomplete {\n  display: inline-flex;\n  position: relative;\n}\n.p-autocomplete-loader {\n  position: absolute;\n  top: 50%;\n  margin-top: -0.5rem;\n}\n.p-autocomplete-item {\n  text-overflow: ellipsis;\n  overflow-x: clip;\n  white-space: nowrap;\n}\n.p-autocomplete .p-autocomplete-input {\n  flex: 1 1 auto;\n  width: 1%;\n}\n.p-autocomplete-dd .p-autocomplete-input,\n.p-autocomplete-dd .p-autocomplete-multiple-container {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: none;\n}\n.p-autocomplete-dd .p-autocomplete-dropdown {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0px;\n  border-left: none;\n}\n.p-autocomplete-dd .p-autocomplete-dropdown,\n.p-autocomplete-dd .p-autocomplete-dropdown:hover {\n  background: white;\n  border-color: var(--gray-20);\n}\n.p-inputtext:enabled:hover + .p-autocomplete-dropdown {\n  border-color: var(--gray-40);\n}\n.p-autocomplete-input:focus + .p-autocomplete-dropdown {\n  border-color: var(--blue-100) !important;\n}\n.p-autocomplete.p-invalid.p-component > .p-inputtext ~ .p-autocomplete-dropdown {\n  border-color: var(--red-100) !important;\n}\n.p-autocomplete.autocomplete-sm .p-button.p-button-icon-only {\n  width: 32px;\n  padding: 6px 0;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n/* messages */\n.p-message .p-message-wrapper {\n  padding: 0.5rem 1rem;\n}\n.p-message:first-child {\n  margin-top: 0;\n}\n.p-message:first-child:last-child {\n  margin-bottom: 0;\n}\n\n/* overlaypanel */\n.p-overlaypanel {\n  background: var(--primary-white);\n  border: 0 none;\n  border-radius: 8px;\n  box-shadow: var(--shadow-level-3);\n}\n.p-overlaypanel .p-overlaypanel-content {\n  padding: 0;\n  height: 100%;\n}\n.p-overlaypanel .p-overlaypanel-close {\n  background: var(--blue-100);\n  color: var(--primary-white);\n  width: 20px;\n  height: 20px;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    box-shadow 0.2s;\n  border-radius: 50%;\n  position: absolute;\n  top: -10px;\n  right: -10px;\n}\n.p-overlaypanel .p-overlaypanel-close:enabled:hover {\n  background: var(--blue-100);\n  color: var(--primary-white);\n}\n.p-overlaypanel:after,\n.p-overlaypanel:before {\n  display: none;\n}\n.p-overlaypanel-flipped {\n  margin: 0;\n  transform: translate(-240px, 12px);\n}\n\n.p-toast .p-toast-message-icon {\n  width: 28px;\n  height: 28px;\n}\n\n/* radiobutton */\n.p-radiobutton {\n  width: 20px;\n  height: 20px;\n}\n.p-radiobutton .p-radiobutton-box {\n  width: 20px;\n  height: 20px;\n  /* color: #495057; */\n  border-radius: 50%;\n  transition:\n    background-color 0.2s,\n    color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n.p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {\n  border-color: var(--blue-100);\n}\n.p-radiobutton .p-radiobutton-box:not(.p-disabled).p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: var(--shadow-focus);\n  border-color: var(--blue-100);\n}\n.p-radiobutton .p-radiobutton-box .p-radiobutton-icon {\n  width: 8px;\n  height: 8px;\n  transition-duration: 0.2s;\n  background-color: var(--primary-white);\n}\n.p-radiobutton .p-radiobutton-box.p-highlight {\n  border-color: var(--blue-100);\n  background: var(--blue-100);\n}\n.p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {\n  border-color: var(--blue-dark);\n  background: var(--blue-dark);\n  color: var(--primary-white);\n}\n.p-radiobutton.p-invalid > .p-radiobutton-box {\n  border-color: var(--red-100);\n}\n.p-radiobutton:focus {\n  outline: 0 none;\n}\n\n.p-input-filled .p-radiobutton .p-radiobutton-box {\n  background-color: var(--gray-1);\n}\n.p-input-filled .p-radiobutton .p-radiobutton-box:not(.p-disabled):hover {\n  background-color: var(--gray-1);\n}\n.p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight {\n  background: var(--blue-100);\n}\n.p-input-filled .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {\n  background: var(--blue-dark);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
